// Code generated by graphql-codegen. DO NOT EDIT.
import * as Types from "../types/generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OfficeItemFragment = {
  __typename?: "Group";
  id: string;
  name: string;
  code: string;
  parent?: {
    __typename?: "Group";
    id: string;
    name: string;
    code: string;
  } | null;
};

export type FetchOfficeQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchOfficeQuery = {
  __typename?: "Query";
  office?: {
    __typename?: "Group";
    id: string;
    name: string;
    code: string;
    parent?: {
      __typename?: "Group";
      id: string;
      name: string;
      code: string;
    } | null;
  } | null;
};

export type SearchOfficesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.GroupQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.GroupOrderInput>>
    | Types.InputMaybe<Types.GroupOrderInput>
  >;
}>;

export type SearchOfficesQuery = {
  __typename?: "Query";
  offices: {
    __typename?: "GroupConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "GroupEdge";
      node: {
        __typename?: "Group";
        id: string;
        name: string;
        code: string;
        parent?: {
          __typename?: "Group";
          id: string;
          name: string;
          code: string;
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type SalesOfficeItemFragment = {
  __typename?: "SalesOffice";
  id: string;
  groupID: string;
  code: string;
  name: string;
  managers: Array<{
    __typename?: "SalesOfficeManagers";
    employeeID: string;
    startAt?: any | null;
    endAt?: any | null;
    roleType: Types.SalesOfficeManagersRoleType;
    userGroupID: string;
    employee?: {
      __typename?: "Employee";
      id: string;
      name: string;
      employeeCode: string;
      employeeCategoryID: string;
      defaultContractCode?: string | null;
      defaultOfficeCode: string;
      defaultScheduledBreakTime?: TailorGqlTime | null;
      defaultScheduledStartedAt?: TailorGqlTime | null;
      defaultScheduledEndedAt?: TailorGqlTime | null;
      joinedAt: TailorGqlDate;
      userID: string;
      employeeCategory?: {
        __typename?: "EmployeeCategory";
        name: string;
        code: number;
      } | null;
      paymentCategory?: {
        __typename?: "PaymentCategory";
        id: string;
        name: string;
        code: number;
      } | null;
      user?: {
        __typename?: "User";
        roles?: Array<string> | null;
        groups?: Array<string> | null;
      } | null;
    } | null;
  }>;
};

export type SearchSalesOfficesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.SalesOfficeQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.SalesOfficeOrderInput>>
    | Types.InputMaybe<Types.SalesOfficeOrderInput>
  >;
}>;

export type SearchSalesOfficesQuery = {
  __typename?: "Query";
  salesOffices: {
    __typename?: "SalesOfficeConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "SalesOfficeEdge";
      node: {
        __typename?: "SalesOffice";
        id: string;
        groupID: string;
        code: string;
        name: string;
        managers: Array<{
          __typename?: "SalesOfficeManagers";
          employeeID: string;
          startAt?: any | null;
          endAt?: any | null;
          roleType: Types.SalesOfficeManagersRoleType;
          userGroupID: string;
          employee?: {
            __typename?: "Employee";
            id: string;
            name: string;
            employeeCode: string;
            employeeCategoryID: string;
            defaultContractCode?: string | null;
            defaultOfficeCode: string;
            defaultScheduledBreakTime?: TailorGqlTime | null;
            defaultScheduledStartedAt?: TailorGqlTime | null;
            defaultScheduledEndedAt?: TailorGqlTime | null;
            joinedAt: TailorGqlDate;
            userID: string;
            employeeCategory?: {
              __typename?: "EmployeeCategory";
              name: string;
              code: number;
            } | null;
            paymentCategory?: {
              __typename?: "PaymentCategory";
              id: string;
              name: string;
              code: number;
            } | null;
            user?: {
              __typename?: "User";
              roles?: Array<string> | null;
              groups?: Array<string> | null;
            } | null;
          } | null;
        }>;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type SearchSalesOfficesOnMasterQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.SalesOfficeQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.SalesOfficeOrderInput>>
    | Types.InputMaybe<Types.SalesOfficeOrderInput>
  >;
}>;

export type SearchSalesOfficesOnMasterQuery = {
  __typename?: "Query";
  salesOffices: {
    __typename?: "SalesOfficeConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "SalesOfficeEdge";
      node: {
        __typename?: "SalesOffice";
        id: string;
        groupID: string;
        code: string;
        name: string;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type FetchSalesOfficeQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchSalesOfficeQuery = {
  __typename?: "Query";
  salesOffice?: {
    __typename?: "SalesOffice";
    id: string;
    groupID: string;
    code: string;
    name: string;
    managers: Array<{
      __typename?: "SalesOfficeManagers";
      employeeID: string;
      startAt?: any | null;
      endAt?: any | null;
      roleType: Types.SalesOfficeManagersRoleType;
      userGroupID: string;
      employee?: {
        __typename?: "Employee";
        id: string;
        name: string;
        employeeCode: string;
        employeeCategoryID: string;
        defaultContractCode?: string | null;
        defaultOfficeCode: string;
        defaultScheduledBreakTime?: TailorGqlTime | null;
        defaultScheduledStartedAt?: TailorGqlTime | null;
        defaultScheduledEndedAt?: TailorGqlTime | null;
        joinedAt: TailorGqlDate;
        userID: string;
        employeeCategory?: {
          __typename?: "EmployeeCategory";
          name: string;
          code: number;
        } | null;
        paymentCategory?: {
          __typename?: "PaymentCategory";
          id: string;
          name: string;
          code: number;
        } | null;
        user?: {
          __typename?: "User";
          roles?: Array<string> | null;
          groups?: Array<string> | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type UpdateSalesOfficeMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
  input: Types.SalesOfficeUpdateInput;
}>;

export type UpdateSalesOfficeMutation = {
  __typename?: "Mutation";
  updateSalesOffice?: {
    __typename?: "SalesOffice";
    id: string;
    groupID: string;
    code: string;
    name: string;
    managers: Array<{
      __typename?: "SalesOfficeManagers";
      employeeID: string;
      startAt?: any | null;
      endAt?: any | null;
      roleType: Types.SalesOfficeManagersRoleType;
      userGroupID: string;
      employee?: {
        __typename?: "Employee";
        id: string;
        name: string;
        employeeCode: string;
        employeeCategoryID: string;
        defaultContractCode?: string | null;
        defaultOfficeCode: string;
        defaultScheduledBreakTime?: TailorGqlTime | null;
        defaultScheduledStartedAt?: TailorGqlTime | null;
        defaultScheduledEndedAt?: TailorGqlTime | null;
        joinedAt: TailorGqlDate;
        userID: string;
        employeeCategory?: {
          __typename?: "EmployeeCategory";
          name: string;
          code: number;
        } | null;
        paymentCategory?: {
          __typename?: "PaymentCategory";
          id: string;
          name: string;
          code: number;
        } | null;
        user?: {
          __typename?: "User";
          roles?: Array<string> | null;
          groups?: Array<string> | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type AddUserToSalesOfficeMutationVariables = Types.Exact<{
  input: Types.AddUserToSalesOfficeInput;
}>;

export type AddUserToSalesOfficeMutation = {
  __typename?: "Mutation";
  addUserToSalesOffice?: string | null;
};

export type DelUserFromSalesOfficeMutationVariables = Types.Exact<{
  input: Types.DeleteUserFromSalesOfficeInput;
}>;

export type DelUserFromSalesOfficeMutation = {
  __typename?: "Mutation";
  deleteUserFromSalesOffice?: boolean | null;
};

export type RoleItemFragment = {
  __typename?: "Role";
  id: string;
  name: string;
  roleClass?: { __typename?: "RoleClass"; id: string; name: string } | null;
};

export type ContractItemFragment = {
  __typename?: "Contract";
  id: string;
  name: string;
  code: string;
  workplaceName: string;
  salesOffice?: {
    __typename?: "SalesOffice";
    id: string;
    groupID: string;
    code: string;
    name: string;
    managers: Array<{
      __typename?: "SalesOfficeManagers";
      employeeID: string;
      startAt?: any | null;
      endAt?: any | null;
      roleType: Types.SalesOfficeManagersRoleType;
      userGroupID: string;
      employee?: {
        __typename?: "Employee";
        id: string;
        name: string;
        employeeCode: string;
        employeeCategoryID: string;
        defaultContractCode?: string | null;
        defaultOfficeCode: string;
        defaultScheduledBreakTime?: TailorGqlTime | null;
        defaultScheduledStartedAt?: TailorGqlTime | null;
        defaultScheduledEndedAt?: TailorGqlTime | null;
        joinedAt: TailorGqlDate;
        userID: string;
        employeeCategory?: {
          __typename?: "EmployeeCategory";
          name: string;
          code: number;
        } | null;
        paymentCategory?: {
          __typename?: "PaymentCategory";
          id: string;
          name: string;
          code: number;
        } | null;
        user?: {
          __typename?: "User";
          roles?: Array<string> | null;
          groups?: Array<string> | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type ManagerItemFragment = {
  __typename?: "ContractManagers";
  employeeID: string;
  startAt?: any | null;
  endAt?: any | null;
  roleType: Types.ContractManagersRoleType;
  userRoleID: string;
  employee?: {
    __typename?: "Employee";
    id: string;
    name: string;
    employeeCode: string;
    employeeCategoryID: string;
    defaultContractCode?: string | null;
    defaultOfficeCode: string;
    defaultScheduledBreakTime?: TailorGqlTime | null;
    defaultScheduledStartedAt?: TailorGqlTime | null;
    defaultScheduledEndedAt?: TailorGqlTime | null;
    joinedAt: TailorGqlDate;
    userID: string;
    employeeCategory?: {
      __typename?: "EmployeeCategory";
      name: string;
      code: number;
    } | null;
    paymentCategory?: {
      __typename?: "PaymentCategory";
      id: string;
      name: string;
      code: number;
    } | null;
    user?: {
      __typename?: "User";
      roles?: Array<string> | null;
      groups?: Array<string> | null;
    } | null;
  } | null;
};

export type ContractDetailItemFragment = {
  __typename?: "Contract";
  id: string;
  name: string;
  code: string;
  workplaceName: string;
  managers: Array<{
    __typename?: "ContractManagers";
    employeeID: string;
    startAt?: any | null;
    endAt?: any | null;
    roleType: Types.ContractManagersRoleType;
    userRoleID: string;
    employee?: {
      __typename?: "Employee";
      id: string;
      name: string;
      employeeCode: string;
      employeeCategoryID: string;
      defaultContractCode?: string | null;
      defaultOfficeCode: string;
      defaultScheduledBreakTime?: TailorGqlTime | null;
      defaultScheduledStartedAt?: TailorGqlTime | null;
      defaultScheduledEndedAt?: TailorGqlTime | null;
      joinedAt: TailorGqlDate;
      userID: string;
      employeeCategory?: {
        __typename?: "EmployeeCategory";
        name: string;
        code: number;
      } | null;
      paymentCategory?: {
        __typename?: "PaymentCategory";
        id: string;
        name: string;
        code: number;
      } | null;
      user?: {
        __typename?: "User";
        roles?: Array<string> | null;
        groups?: Array<string> | null;
      } | null;
    } | null;
  }>;
};

export type SearchContractsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.ContractQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.ContractOrderInput>>
    | Types.InputMaybe<Types.ContractOrderInput>
  >;
}>;

export type SearchContractsQuery = {
  __typename?: "Query";
  contracts: {
    __typename?: "ContractConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "ContractEdge";
      node: {
        __typename?: "Contract";
        id: string;
        name: string;
        workplaceName: string;
        code: string;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type SearchContractsOnMasterQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.ContractQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.ContractOrderInput>>
    | Types.InputMaybe<Types.ContractOrderInput>
  >;
}>;

export type SearchContractsOnMasterQuery = {
  __typename?: "Query";
  contracts: {
    __typename?: "ContractConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "ContractEdge";
      node: {
        __typename?: "Contract";
        id: string;
        name: string;
        code: string;
        workplaceName: string;
        salesOffice?: {
          __typename?: "SalesOffice";
          id: string;
          name: string;
          code: string;
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type FetchContractQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchContractQuery = {
  __typename?: "Query";
  contract?: {
    __typename?: "Contract";
    id: string;
    name: string;
    code: string;
    workplaceName: string;
    managers: Array<{
      __typename?: "ContractManagers";
      employeeID: string;
      startAt?: any | null;
      endAt?: any | null;
      roleType: Types.ContractManagersRoleType;
      userRoleID: string;
      employee?: {
        __typename?: "Employee";
        id: string;
        name: string;
        employeeCode: string;
        employeeCategoryID: string;
        defaultContractCode?: string | null;
        defaultOfficeCode: string;
        defaultScheduledBreakTime?: TailorGqlTime | null;
        defaultScheduledStartedAt?: TailorGqlTime | null;
        defaultScheduledEndedAt?: TailorGqlTime | null;
        joinedAt: TailorGqlDate;
        userID: string;
        employeeCategory?: {
          __typename?: "EmployeeCategory";
          name: string;
          code: number;
        } | null;
        paymentCategory?: {
          __typename?: "PaymentCategory";
          id: string;
          name: string;
          code: number;
        } | null;
        user?: {
          __typename?: "User";
          roles?: Array<string> | null;
          groups?: Array<string> | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type UpdateContractMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
  input: Types.ContractUpdateInput;
}>;

export type UpdateContractMutation = {
  __typename?: "Mutation";
  updateContract?: {
    __typename?: "Contract";
    id: string;
    name: string;
    code: string;
    workplaceName: string;
    managers: Array<{
      __typename?: "ContractManagers";
      employeeID: string;
      startAt?: any | null;
      endAt?: any | null;
      roleType: Types.ContractManagersRoleType;
      userRoleID: string;
      employee?: {
        __typename?: "Employee";
        id: string;
        name: string;
        employeeCode: string;
        employeeCategoryID: string;
        defaultContractCode?: string | null;
        defaultOfficeCode: string;
        defaultScheduledBreakTime?: TailorGqlTime | null;
        defaultScheduledStartedAt?: TailorGqlTime | null;
        defaultScheduledEndedAt?: TailorGqlTime | null;
        joinedAt: TailorGqlDate;
        userID: string;
        employeeCategory?: {
          __typename?: "EmployeeCategory";
          name: string;
          code: number;
        } | null;
        paymentCategory?: {
          __typename?: "PaymentCategory";
          id: string;
          name: string;
          code: number;
        } | null;
        user?: {
          __typename?: "User";
          roles?: Array<string> | null;
          groups?: Array<string> | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type AddUserToContractMutationVariables = Types.Exact<{
  input: Types.AddUserToContractInput;
}>;

export type AddUserToContractMutation = {
  __typename?: "Mutation";
  addUserToContract?: string | null;
};

export type DelUserFromContractMutationVariables = Types.Exact<{
  input: Types.DeleteUserFromContractInput;
}>;

export type DelUserFromContractMutation = {
  __typename?: "Mutation";
  deleteUserFromContract?: boolean | null;
};

export type RecordTypeItemFragment = {
  __typename?: "RecordType";
  id: string;
  name: string;
  isHoliday?: boolean | null;
  isCommentable: boolean;
  needTimeInput?: boolean | null;
  needLateTime?: boolean | null;
  needTransportCosts?: boolean | null;
  useUserInputPrescribedTime?: boolean | null;
  useDefaultPrescribedTime?: boolean | null;
  displayPriority?: number | null;
};

export type FetchRecordTypesQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.RecordTypeOrderInput>>
    | Types.InputMaybe<Types.RecordTypeOrderInput>
  >;
}>;

export type FetchRecordTypesQuery = {
  __typename?: "Query";
  recordTypes: {
    __typename?: "RecordTypeConnection";
    edges: Array<{
      __typename?: "RecordTypeEdge";
      node: {
        __typename?: "RecordType";
        id: string;
        name: string;
        isHoliday?: boolean | null;
        isCommentable: boolean;
        needTimeInput?: boolean | null;
        needLateTime?: boolean | null;
        needTransportCosts?: boolean | null;
        useUserInputPrescribedTime?: boolean | null;
        useDefaultPrescribedTime?: boolean | null;
        displayPriority?: number | null;
      };
    }>;
  };
};

export type SearchApplicationDatesQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.WorkRecordQueryInput>;
}>;

export type SearchApplicationDatesQuery = {
  __typename?: "Query";
  workRecords: {
    __typename?: "WorkRecordConnection";
    edges: Array<{
      __typename?: "WorkRecordEdge";
      node: { __typename?: "WorkRecord"; applicationDate: TailorGqlDate };
    }>;
  };
};

export type EmployeeItemFragment = {
  __typename?: "Employee";
  id: string;
  name: string;
  employeeCode: string;
  employeeCategoryID: string;
  defaultContractCode?: string | null;
  defaultOfficeCode: string;
  defaultScheduledBreakTime?: TailorGqlTime | null;
  defaultScheduledStartedAt?: TailorGqlTime | null;
  defaultScheduledEndedAt?: TailorGqlTime | null;
  joinedAt: TailorGqlDate;
  userID: string;
  employeeCategory?: {
    __typename?: "EmployeeCategory";
    name: string;
    code: number;
  } | null;
  paymentCategory?: {
    __typename?: "PaymentCategory";
    id: string;
    name: string;
    code: number;
  } | null;
  user?: {
    __typename?: "User";
    roles?: Array<string> | null;
    groups?: Array<string> | null;
  } | null;
};

export type WorkRecordItemFragment = {
  __typename?: "WorkRecord";
  id: string;
  applicantCategoryCode: string;
  applicantCode?: string | null;
  applicantID: string;
  applicantName?: string | null;
  applicationDate: TailorGqlDate;
  employeeCategory?: string | null;
  contractID: string;
  contractCode: string;
  contractName?: string | null;
  contractWorkplaceName?: string | null;
  recordTypeID: string;
  startedAt?: TailorGqlTime | null;
  endedAt?: TailorGqlTime | null;
  breakTime?: TailorGqlTime | null;
  lateTime?: TailorGqlTime | null;
  lateWorkingTime?: TailorGqlTime | null;
  legalOverworkingTime?: TailorGqlTime | null;
  legalWorkingTime?: TailorGqlTime | null;
  scheduledStartedAt?: TailorGqlTime | null;
  scheduledEndedAt?: TailorGqlTime | null;
  scheduledBreakTime?: TailorGqlTime | null;
  workingTime?: TailorGqlTime | null;
  holidayWorkingTime?: TailorGqlTime | null;
  inPrescribedTime?: TailorGqlTime | null;
  statutoryOverworkingTime?: TailorGqlTime | null;
  bindingTime?: TailorGqlTime | null;
  prescribedTime?: TailorGqlTime | null;
  workComment?: string | null;
  transportCostType?: Types.WorkRecordTransportCostType | null;
  stateID: string;
  currentState: string;
  applicant?: {
    __typename?: "Employee";
    name: string;
    employeeCode: string;
    employeeCategory?: { __typename?: "EmployeeCategory"; name: string } | null;
  } | null;
  contract?: { __typename?: "Contract"; name: string; code: string } | null;
  recordType?: {
    __typename?: "RecordType";
    id: string;
    name: string;
    isHoliday?: boolean | null;
    isCommentable: boolean;
    needTimeInput?: boolean | null;
    needLateTime?: boolean | null;
    needTransportCosts?: boolean | null;
    useUserInputPrescribedTime?: boolean | null;
    useDefaultPrescribedTime?: boolean | null;
    displayPriority?: number | null;
  } | null;
  state?: {
    __typename?: "State";
    id: string;
    name?: string | null;
    currentState?: string | null;
  } | null;
};

export type DeletedWorkRecordItemFragment = {
  __typename?: "DeletedWorkRecord";
  id: string;
  applicationDate: TailorGqlDate;
  applicantID: string;
  contractID: string;
  recordTypeID: string;
  startedAt?: TailorGqlTime | null;
  endedAt?: TailorGqlTime | null;
  breakTime?: TailorGqlTime | null;
  lateTime?: TailorGqlTime | null;
  lateWorkingTime?: TailorGqlTime | null;
  legalOverworkingTime?: TailorGqlTime | null;
  legalWorkingTime?: TailorGqlTime | null;
  scheduledStartedAt?: TailorGqlTime | null;
  scheduledEndedAt?: TailorGqlTime | null;
  scheduledBreakTime?: TailorGqlTime | null;
  workingTime?: TailorGqlTime | null;
  holidayWorkingTime?: TailorGqlTime | null;
  inPrescribedTime?: TailorGqlTime | null;
  statutoryOverworkingTime?: TailorGqlTime | null;
  bindingTime?: TailorGqlTime | null;
  prescribedTime?: TailorGqlTime | null;
  workComment?: string | null;
  transportCostType?: Types.DeletedWorkRecordTransportCostType | null;
  stateID: string;
  currentState: string;
  deletedDate: TailorGqlDate;
  deleteReason?: string | null;
  applicant?: {
    __typename?: "Employee";
    name: string;
    employeeCode: string;
    employeeCategory?: { __typename?: "EmployeeCategory"; name: string } | null;
  } | null;
  contract?: { __typename?: "Contract"; name: string; code: string } | null;
  recordType?: {
    __typename?: "RecordType";
    id: string;
    name: string;
    isHoliday?: boolean | null;
    isCommentable: boolean;
    needTimeInput?: boolean | null;
    needLateTime?: boolean | null;
    needTransportCosts?: boolean | null;
    useUserInputPrescribedTime?: boolean | null;
    useDefaultPrescribedTime?: boolean | null;
    displayPriority?: number | null;
  } | null;
  state?: {
    __typename?: "State";
    id: string;
    name?: string | null;
    currentState?: string | null;
  } | null;
  deletedBy?: { __typename?: "Employee"; name: string } | null;
};

export type SearchWorkRecordsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.WorkRecordQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.WorkRecordOrderInput>>
    | Types.InputMaybe<Types.WorkRecordOrderInput>
  >;
}>;

export type SearchWorkRecordsQuery = {
  __typename?: "Query";
  workRecords: {
    __typename?: "WorkRecordConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "WorkRecordEdge";
      node: {
        __typename?: "WorkRecord";
        id: string;
        applicantCategoryCode: string;
        applicantCode?: string | null;
        applicantID: string;
        applicantName?: string | null;
        applicationDate: TailorGqlDate;
        employeeCategory?: string | null;
        contractID: string;
        contractCode: string;
        contractName?: string | null;
        contractWorkplaceName?: string | null;
        recordTypeID: string;
        startedAt?: TailorGqlTime | null;
        endedAt?: TailorGqlTime | null;
        breakTime?: TailorGqlTime | null;
        lateTime?: TailorGqlTime | null;
        lateWorkingTime?: TailorGqlTime | null;
        legalOverworkingTime?: TailorGqlTime | null;
        legalWorkingTime?: TailorGqlTime | null;
        scheduledStartedAt?: TailorGqlTime | null;
        scheduledEndedAt?: TailorGqlTime | null;
        scheduledBreakTime?: TailorGqlTime | null;
        workingTime?: TailorGqlTime | null;
        holidayWorkingTime?: TailorGqlTime | null;
        inPrescribedTime?: TailorGqlTime | null;
        statutoryOverworkingTime?: TailorGqlTime | null;
        bindingTime?: TailorGqlTime | null;
        prescribedTime?: TailorGqlTime | null;
        workComment?: string | null;
        transportCostType?: Types.WorkRecordTransportCostType | null;
        stateID: string;
        currentState: string;
        applicant?: {
          __typename?: "Employee";
          name: string;
          employeeCode: string;
          employeeCategory?: {
            __typename?: "EmployeeCategory";
            name: string;
          } | null;
        } | null;
        contract?: {
          __typename?: "Contract";
          name: string;
          code: string;
        } | null;
        recordType?: {
          __typename?: "RecordType";
          id: string;
          name: string;
          isHoliday?: boolean | null;
          isCommentable: boolean;
          needTimeInput?: boolean | null;
          needLateTime?: boolean | null;
          needTransportCosts?: boolean | null;
          useUserInputPrescribedTime?: boolean | null;
          useDefaultPrescribedTime?: boolean | null;
          displayPriority?: number | null;
        } | null;
        state?: {
          __typename?: "State";
          id: string;
          name?: string | null;
          currentState?: string | null;
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type SearchDeletedWorkRecordsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.DeletedWorkRecordQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.DeletedWorkRecordOrderInput>>
    | Types.InputMaybe<Types.DeletedWorkRecordOrderInput>
  >;
}>;

export type SearchDeletedWorkRecordsQuery = {
  __typename?: "Query";
  deletedWorkRecords: {
    __typename?: "DeletedWorkRecordConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "DeletedWorkRecordEdge";
      node: {
        __typename?: "DeletedWorkRecord";
        id: string;
        applicationDate: TailorGqlDate;
        applicantID: string;
        contractID: string;
        recordTypeID: string;
        startedAt?: TailorGqlTime | null;
        endedAt?: TailorGqlTime | null;
        breakTime?: TailorGqlTime | null;
        lateTime?: TailorGqlTime | null;
        lateWorkingTime?: TailorGqlTime | null;
        legalOverworkingTime?: TailorGqlTime | null;
        legalWorkingTime?: TailorGqlTime | null;
        scheduledStartedAt?: TailorGqlTime | null;
        scheduledEndedAt?: TailorGqlTime | null;
        scheduledBreakTime?: TailorGqlTime | null;
        workingTime?: TailorGqlTime | null;
        holidayWorkingTime?: TailorGqlTime | null;
        inPrescribedTime?: TailorGqlTime | null;
        statutoryOverworkingTime?: TailorGqlTime | null;
        bindingTime?: TailorGqlTime | null;
        prescribedTime?: TailorGqlTime | null;
        workComment?: string | null;
        transportCostType?: Types.DeletedWorkRecordTransportCostType | null;
        stateID: string;
        currentState: string;
        deletedDate: TailorGqlDate;
        deleteReason?: string | null;
        applicant?: {
          __typename?: "Employee";
          name: string;
          employeeCode: string;
          employeeCategory?: {
            __typename?: "EmployeeCategory";
            name: string;
          } | null;
        } | null;
        contract?: {
          __typename?: "Contract";
          name: string;
          code: string;
        } | null;
        recordType?: {
          __typename?: "RecordType";
          id: string;
          name: string;
          isHoliday?: boolean | null;
          isCommentable: boolean;
          needTimeInput?: boolean | null;
          needLateTime?: boolean | null;
          needTransportCosts?: boolean | null;
          useUserInputPrescribedTime?: boolean | null;
          useDefaultPrescribedTime?: boolean | null;
          displayPriority?: number | null;
        } | null;
        state?: {
          __typename?: "State";
          id: string;
          name?: string | null;
          currentState?: string | null;
        } | null;
        deletedBy?: { __typename?: "Employee"; name: string } | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type ApplyWorkRecordMutationVariables = Types.Exact<{
  input: Types.ApplyWorkRecordInput;
}>;

export type ApplyWorkRecordMutation = {
  __typename?: "Mutation";
  applyWorkRecord?: string | null;
};

export type UpdateWorkRecordMutationVariables = Types.Exact<{
  input: Types.EditWorkRecordInput;
}>;

export type UpdateWorkRecordMutation = {
  __typename?: "Mutation";
  editWorkRecord?: string | null;
};

export type ApproveWorkRecordMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
  action: Types.Scalars["String"]["input"];
}>;

export type ApproveWorkRecordMutation = {
  __typename?: "Mutation";
  punchWorkRecord?: {
    __typename?: "PunchWorkRecordResult";
    id?: string | null;
    currentState?: string | null;
  } | null;
};

export type ProfileFragment = {
  __typename?: "User";
  id: string;
  username: string;
  displayName?: string | null;
  groups?: Array<string> | null;
  roles?: Array<string> | null;
};

export type MeForProfileQueryVariables = Types.Exact<{ [key: string]: never }>;

export type MeForProfileQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "User";
    id: string;
    username: string;
    displayName?: string | null;
    groups?: Array<string> | null;
    roles?: Array<string> | null;
  } | null;
};

export type GetUserQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type GetUserQuery = {
  __typename?: "Query";
  user?: {
    __typename?: "User";
    id: string;
    username: string;
    displayName?: string | null;
    groups?: Array<string> | null;
    roles?: Array<string> | null;
  } | null;
};

export type FetchRolesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.RoleQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.RoleOrderInput>>
    | Types.InputMaybe<Types.RoleOrderInput>
  >;
}>;

export type FetchRolesQuery = {
  __typename?: "Query";
  roles: {
    __typename?: "RoleConnection";
    total?: number | null;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: "RoleEdge";
      node: {
        __typename?: "Role";
        id: string;
        name: string;
        roleClassID: string;
        roleClass?: {
          __typename?: "RoleClass";
          id: string;
          name: string;
        } | null;
      };
    }>;
  };
};

export type FetchGroupsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.GroupQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.GroupOrderInput>>
    | Types.InputMaybe<Types.GroupOrderInput>
  >;
}>;

export type FetchGroupsQuery = {
  __typename?: "Query";
  groups: {
    __typename?: "GroupConnection";
    total?: number | null;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: "GroupEdge";
      node: {
        __typename?: "Group";
        id: string;
        name: string;
        code: string;
        parentId?: string | null;
        parent?: {
          __typename?: "Group";
          id: string;
          name: string;
          code: string;
        } | null;
      };
    }>;
  };
};

export type FetchEmployeeByUserIdQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchEmployeeByUserIdQuery = {
  __typename?: "Query";
  employees: {
    __typename?: "EmployeeConnection";
    edges: Array<{
      __typename?: "EmployeeEdge";
      node: {
        __typename?: "Employee";
        id: string;
        name: string;
        employeeCode: string;
        employeeCategoryID: string;
        defaultContractCode?: string | null;
        defaultOfficeCode: string;
        defaultScheduledBreakTime?: TailorGqlTime | null;
        defaultScheduledStartedAt?: TailorGqlTime | null;
        defaultScheduledEndedAt?: TailorGqlTime | null;
        joinedAt: TailorGqlDate;
        userID: string;
        employeeCategory?: {
          __typename?: "EmployeeCategory";
          name: string;
          code: number;
        } | null;
        paymentCategory?: {
          __typename?: "PaymentCategory";
          id: string;
          name: string;
          code: number;
        } | null;
        user?: {
          __typename?: "User";
          roles?: Array<string> | null;
          groups?: Array<string> | null;
        } | null;
      };
    }>;
  };
};

export type FetchEmployeeQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchEmployeeQuery = {
  __typename?: "Query";
  employee?: {
    __typename?: "Employee";
    id: string;
    name: string;
    employeeCode: string;
    employeeCategoryID: string;
    defaultContractCode?: string | null;
    defaultOfficeCode: string;
    defaultScheduledBreakTime?: TailorGqlTime | null;
    defaultScheduledStartedAt?: TailorGqlTime | null;
    defaultScheduledEndedAt?: TailorGqlTime | null;
    joinedAt: TailorGqlDate;
    userID: string;
    employeeCategory?: {
      __typename?: "EmployeeCategory";
      name: string;
      code: number;
    } | null;
    paymentCategory?: {
      __typename?: "PaymentCategory";
      id: string;
      name: string;
      code: number;
    } | null;
    user?: {
      __typename?: "User";
      roles?: Array<string> | null;
      groups?: Array<string> | null;
    } | null;
  } | null;
};

export type SearchEmployeesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.EmployeeQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.EmployeeOrderInput>>
    | Types.InputMaybe<Types.EmployeeOrderInput>
  >;
}>;

export type SearchEmployeesQuery = {
  __typename?: "Query";
  employees: {
    __typename?: "EmployeeConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "EmployeeEdge";
      node: {
        __typename?: "Employee";
        id: string;
        name: string;
        employeeCode: string;
        employeeCategoryID: string;
        defaultContractCode?: string | null;
        defaultOfficeCode: string;
        defaultScheduledBreakTime?: TailorGqlTime | null;
        defaultScheduledStartedAt?: TailorGqlTime | null;
        defaultScheduledEndedAt?: TailorGqlTime | null;
        joinedAt: TailorGqlDate;
        userID: string;
        employeeCategory?: {
          __typename?: "EmployeeCategory";
          name: string;
          code: number;
        } | null;
        paymentCategory?: {
          __typename?: "PaymentCategory";
          id: string;
          name: string;
          code: number;
        } | null;
        user?: {
          __typename?: "User";
          roles?: Array<string> | null;
          groups?: Array<string> | null;
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type UpdateEmployeeMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
  input: Types.EmployeeUpdateInput;
}>;

export type UpdateEmployeeMutation = {
  __typename?: "Mutation";
  updateEmployee?: { __typename?: "Employee"; id: string } | null;
};

export type MoveWorkrecordToDeletedWorkrecordMutationVariables = Types.Exact<{
  currentState: Types.Scalars["String"]["input"];
  deleteReason?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  deletedDate: Types.Scalars["Date"]["input"];
  id: Types.Scalars["ID"]["input"];
}>;

export type MoveWorkrecordToDeletedWorkrecordMutation = {
  __typename?: "Mutation";
  moveToDeletedWorkrecord?: boolean | null;
};

export type EmployeeWorkingTimeItemFragment = {
  __typename?: "EmployeeWorkingTime";
  id: string;
  employeeID: string;
  value: TailorGqlTime;
  startDate: TailorGqlDate;
  endDate: TailorGqlDate;
  employee?: {
    __typename?: "Employee";
    id: string;
    name: string;
    employeeCode: string;
    employeeCategoryID: string;
    defaultContractCode?: string | null;
    defaultOfficeCode: string;
    defaultScheduledBreakTime?: TailorGqlTime | null;
    defaultScheduledStartedAt?: TailorGqlTime | null;
    defaultScheduledEndedAt?: TailorGqlTime | null;
    joinedAt: TailorGqlDate;
    userID: string;
    employeeCategory?: {
      __typename?: "EmployeeCategory";
      name: string;
      code: number;
    } | null;
    paymentCategory?: {
      __typename?: "PaymentCategory";
      id: string;
      name: string;
      code: number;
    } | null;
    user?: {
      __typename?: "User";
      roles?: Array<string> | null;
      groups?: Array<string> | null;
    } | null;
  } | null;
};

export type SettingEmployeeWorkingTimesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.EmployeeWorkingTimeQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.EmployeeWorkingTimeOrderInput>>
    | Types.InputMaybe<Types.EmployeeWorkingTimeOrderInput>
  >;
}>;

export type SettingEmployeeWorkingTimesQuery = {
  __typename?: "Query";
  employeeWorkingTimes: {
    __typename?: "EmployeeWorkingTimeConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "EmployeeWorkingTimeEdge";
      node: {
        __typename?: "EmployeeWorkingTime";
        id: string;
        employeeID: string;
        value: TailorGqlTime;
        startDate: TailorGqlDate;
        endDate: TailorGqlDate;
        employee?: {
          __typename?: "Employee";
          id: string;
          name: string;
          employeeCode: string;
          employeeCategoryID: string;
          defaultContractCode?: string | null;
          defaultOfficeCode: string;
          defaultScheduledBreakTime?: TailorGqlTime | null;
          defaultScheduledStartedAt?: TailorGqlTime | null;
          defaultScheduledEndedAt?: TailorGqlTime | null;
          joinedAt: TailorGqlDate;
          userID: string;
          employeeCategory?: {
            __typename?: "EmployeeCategory";
            name: string;
            code: number;
          } | null;
          paymentCategory?: {
            __typename?: "PaymentCategory";
            id: string;
            name: string;
            code: number;
          } | null;
          user?: {
            __typename?: "User";
            roles?: Array<string> | null;
            groups?: Array<string> | null;
          } | null;
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type EditSettingEmployeeWorkingTimeMutationVariables = Types.Exact<{
  input: Types.EditEmployeeWorkingTimeInput;
}>;

export type EditSettingEmployeeWorkingTimeMutation = {
  __typename?: "Mutation";
  editEmployeeWorkingTime?: string | null;
};

export type AddSettingEmployeeWorkingTimeMutationVariables = Types.Exact<{
  input: Types.AddEmployeeWorkingTimeInput;
}>;

export type AddSettingEmployeeWorkingTimeMutation = {
  __typename?: "Mutation";
  addEmployeeWorkingTime?: string | null;
};

export type DeleteSettingEmployeeWorkingTimeMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type DeleteSettingEmployeeWorkingTimeMutation = {
  __typename?: "Mutation";
  deleteEmployeeWorkingTime?: boolean | null;
};

export type ContractSummariesQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ContractSummariesInput>;
}>;

export type ContractSummariesQuery = {
  __typename?: "Query";
  contractSummaries?: {
    __typename?: "ContractSummariesResult";
    total: number;
    collection?: Array<{
      __typename?: "ContractSummary";
      contract?: {
        __typename?: "BasicContractInfo";
        id: string;
        name?: string | null;
        workplaceName?: string | null;
        code?: string | null;
        salesOffice?: {
          __typename?: "BasicSalesOfficeInfo";
          name?: string | null;
        } | null;
      } | null;
      workRecordSummaries?: {
        __typename?: "WorkRecordSummaries";
        holidayCount?: number | null;
        collection?: Array<{
          __typename?: "WorkRecordSummary";
          currentState?: string | null;
          count?: number | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type EmployeeSummariesQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.EmployeeSummariesInput>;
}>;

export type EmployeeSummariesQuery = {
  __typename?: "Query";
  employeeSummaries?: {
    __typename?: "EmployeeSummariesResult";
    total: number;
    collection?: Array<{
      __typename?: "EmployeeSummary";
      employee?: {
        __typename?: "BasicEmployeeInfo";
        id?: string | null;
        name: string;
        code?: string | null;
      } | null;
      workRecordSummaries?: {
        __typename?: "WorkRecordSummaries";
        holidayCount?: number | null;
        collection?: Array<{
          __typename?: "WorkRecordSummary";
          currentState?: string | null;
          count?: number | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CloseMonthMutationVariables = Types.Exact<{
  input: Types.CloseMonthInput;
}>;

export type CloseMonthMutation = {
  __typename?: "Mutation";
  closeMonth?: string | null;
};

export type FetchEmployeeCategoriesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type FetchEmployeeCategoriesQuery = {
  __typename?: "Query";
  employeeCategories: {
    __typename?: "EmployeeCategoryConnection";
    edges: Array<{
      __typename?: "EmployeeCategoryEdge";
      node: {
        __typename?: "EmployeeCategory";
        id: string;
        name: string;
        code: number;
      };
    }>;
  };
};

export type HolidayRecordQueryVariables = Types.Exact<{ [key: string]: never }>;

export type HolidayRecordQuery = {
  __typename?: "Query";
  recordTypes: {
    __typename?: "RecordTypeConnection";
    edges: Array<{
      __typename?: "RecordTypeEdge";
      node: { __typename?: "RecordType"; id: string; name: string };
    }>;
  };
};

export type CloseStatusesQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.CloseStatusQueryInput>;
}>;

export type CloseStatusesQuery = {
  __typename?: "Query";
  closeStatuses: {
    __typename?: "CloseStatusConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "CloseStatusEdge";
      node: {
        __typename?: "CloseStatus";
        status: Types.CloseStatusStatus;
        id: string;
        contractID: string;
        closeDate: TailorGqlDate;
        updatedByID?: string | null;
        executedAt?: any | null;
        executedById?: string | null;
      };
    }>;
  };
};

export type StateApproveHistoriesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  before?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  query?: Types.InputMaybe<Types.StateApproveHistoryQueryInput>;
  order?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.StateApproveHistoryOrderInput>>
    | Types.InputMaybe<Types.StateApproveHistoryOrderInput>
  >;
}>;

export type StateApproveHistoriesQuery = {
  __typename?: "Query";
  stateApproveHistories: {
    __typename?: "StateApproveHistoryConnection";
    total?: number | null;
    edges: Array<{
      __typename?: "StateApproveHistoryEdge";
      node: {
        __typename?: "StateApproveHistory";
        id: string;
        state: string;
        stateID: string;
        action: string;
        approver: string;
        approvedAt: any;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type StateApproveHistoryItemFragment = {
  __typename?: "StateApproveHistory";
  id: string;
  state: string;
  stateID: string;
  action: string;
  approver: string;
  approvedAt: any;
};

export const OfficeItemFragmentDoc = gql`
  fragment OfficeItem on Group {
    id
    name
    code
    parent {
      id
      name
      code
    }
  }
`;
export const RoleItemFragmentDoc = gql`
  fragment RoleItem on Role {
    id
    name
    roleClass {
      id
      name
    }
  }
`;
export const EmployeeItemFragmentDoc = gql`
  fragment EmployeeItem on Employee {
    id
    name
    employeeCode
    employeeCategoryID
    employeeCategory {
      name
      code
    }
    defaultContractCode
    defaultOfficeCode
    defaultScheduledBreakTime
    defaultScheduledStartedAt
    defaultScheduledEndedAt
    joinedAt
    paymentCategory {
      id
      name
      code
    }
    userID
    user {
      roles
      groups
    }
  }
`;
export const SalesOfficeItemFragmentDoc = gql`
  fragment SalesOfficeItem on SalesOffice {
    id
    groupID
    code
    name
    managers {
      employeeID
      startAt
      endAt
      roleType
      userGroupID
      employee {
        ...EmployeeItem
      }
    }
  }
  ${EmployeeItemFragmentDoc}
`;
export const ContractItemFragmentDoc = gql`
  fragment ContractItem on Contract {
    id
    name
    code
    workplaceName
    salesOffice {
      ...SalesOfficeItem
    }
  }
  ${SalesOfficeItemFragmentDoc}
`;
export const ManagerItemFragmentDoc = gql`
  fragment ManagerItem on ContractManagers {
    employeeID
    startAt
    endAt
    roleType
    userRoleID
    employee {
      ...EmployeeItem
    }
  }
  ${EmployeeItemFragmentDoc}
`;
export const ContractDetailItemFragmentDoc = gql`
  fragment ContractDetailItem on Contract {
    id
    name
    code
    workplaceName
    managers {
      ...ManagerItem
    }
  }
  ${ManagerItemFragmentDoc}
`;
export const RecordTypeItemFragmentDoc = gql`
  fragment RecordTypeItem on RecordType {
    id
    name
    isHoliday
    isCommentable
    needTimeInput
    needLateTime
    needTransportCosts
    useUserInputPrescribedTime
    useDefaultPrescribedTime
    displayPriority
  }
`;
export const WorkRecordItemFragmentDoc = gql`
  fragment WorkRecordItem on WorkRecord {
    id
    applicantCategoryCode
    applicantCode
    applicantID
    applicantName
    applicationDate
    applicant {
      name
      employeeCode
      employeeCategory {
        name
      }
    }
    employeeCategory
    contractID
    contractCode
    contractName
    contractWorkplaceName
    contract {
      name
      code
    }
    recordTypeID
    recordType {
      ...RecordTypeItem
    }
    startedAt
    endedAt
    breakTime
    lateTime
    lateWorkingTime
    legalOverworkingTime
    legalWorkingTime
    scheduledStartedAt
    scheduledEndedAt
    scheduledBreakTime
    workingTime
    holidayWorkingTime
    inPrescribedTime
    statutoryOverworkingTime
    bindingTime
    prescribedTime
    legalOverworkingTime
    workComment
    transportCostType
    stateID
    currentState
    state {
      id
      name
      currentState
    }
  }
  ${RecordTypeItemFragmentDoc}
`;
export const DeletedWorkRecordItemFragmentDoc = gql`
  fragment DeletedWorkRecordItem on DeletedWorkRecord {
    id
    applicationDate
    applicantID
    applicant {
      name
      employeeCode
      employeeCategory {
        name
      }
    }
    contractID
    contract {
      name
      code
    }
    recordTypeID
    recordType {
      ...RecordTypeItem
    }
    startedAt
    endedAt
    breakTime
    lateTime
    lateWorkingTime
    legalOverworkingTime
    legalWorkingTime
    scheduledStartedAt
    scheduledEndedAt
    scheduledBreakTime
    workingTime
    holidayWorkingTime
    inPrescribedTime
    statutoryOverworkingTime
    bindingTime
    prescribedTime
    legalOverworkingTime
    workComment
    transportCostType
    stateID
    currentState
    state {
      id
      name
      currentState
    }
    deletedBy {
      name
    }
    deletedDate
    deleteReason
  }
  ${RecordTypeItemFragmentDoc}
`;
export const ProfileFragmentDoc = gql`
  fragment Profile on User {
    id
    username
    displayName
    groups
    roles
  }
`;
export const EmployeeWorkingTimeItemFragmentDoc = gql`
  fragment EmployeeWorkingTimeItem on EmployeeWorkingTime {
    id
    employeeID
    value
    startDate
    endDate
    employee {
      ...EmployeeItem
    }
  }
  ${EmployeeItemFragmentDoc}
`;
export const StateApproveHistoryItemFragmentDoc = gql`
  fragment stateApproveHistoryItem on StateApproveHistory {
    id
    state
    stateID
    action
    approver
    approvedAt
  }
`;
export const FetchOfficeDocument = gql`
  query fetchOffice($id: ID!) {
    office: group(id: $id) {
      ...OfficeItem
    }
  }
  ${OfficeItemFragmentDoc}
`;

/**
 * __useFetchOfficeQuery__
 *
 * To run a query within a React component, call `useFetchOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOfficeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchOfficeQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchOfficeQuery,
    FetchOfficeQueryVariables
  > &
    (
      | { variables: FetchOfficeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchOfficeQuery, FetchOfficeQueryVariables>(
    FetchOfficeDocument,
    options,
  );
}
export function useFetchOfficeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchOfficeQuery,
    FetchOfficeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchOfficeQuery, FetchOfficeQueryVariables>(
    FetchOfficeDocument,
    options,
  );
}
export function useFetchOfficeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchOfficeQuery,
        FetchOfficeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FetchOfficeQuery, FetchOfficeQueryVariables>(
    FetchOfficeDocument,
    options,
  );
}
export type FetchOfficeQueryHookResult = ReturnType<typeof useFetchOfficeQuery>;
export type FetchOfficeLazyQueryHookResult = ReturnType<
  typeof useFetchOfficeLazyQuery
>;
export type FetchOfficeSuspenseQueryHookResult = ReturnType<
  typeof useFetchOfficeSuspenseQuery
>;
export type FetchOfficeQueryResult = Apollo.QueryResult<
  FetchOfficeQuery,
  FetchOfficeQueryVariables
>;
export const SearchOfficesDocument = gql`
  query searchOffices(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: GroupQueryInput
    $order: [GroupOrderInput]
  ) {
    offices: groups(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          ...OfficeItem
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
  ${OfficeItemFragmentDoc}
`;

/**
 * __useSearchOfficesQuery__
 *
 * To run a query within a React component, call `useSearchOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOfficesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchOfficesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchOfficesQuery,
    SearchOfficesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchOfficesQuery, SearchOfficesQueryVariables>(
    SearchOfficesDocument,
    options,
  );
}
export function useSearchOfficesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchOfficesQuery,
    SearchOfficesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchOfficesQuery, SearchOfficesQueryVariables>(
    SearchOfficesDocument,
    options,
  );
}
export function useSearchOfficesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchOfficesQuery,
        SearchOfficesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchOfficesQuery,
    SearchOfficesQueryVariables
  >(SearchOfficesDocument, options);
}
export type SearchOfficesQueryHookResult = ReturnType<
  typeof useSearchOfficesQuery
>;
export type SearchOfficesLazyQueryHookResult = ReturnType<
  typeof useSearchOfficesLazyQuery
>;
export type SearchOfficesSuspenseQueryHookResult = ReturnType<
  typeof useSearchOfficesSuspenseQuery
>;
export type SearchOfficesQueryResult = Apollo.QueryResult<
  SearchOfficesQuery,
  SearchOfficesQueryVariables
>;
export const SearchSalesOfficesDocument = gql`
  query searchSalesOffices(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: SalesOfficeQueryInput
    $order: [SalesOfficeOrderInput]
  ) {
    salesOffices: salesOffices(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          ...SalesOfficeItem
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
  ${SalesOfficeItemFragmentDoc}
`;

/**
 * __useSearchSalesOfficesQuery__
 *
 * To run a query within a React component, call `useSearchSalesOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSalesOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSalesOfficesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchSalesOfficesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchSalesOfficesQuery,
    SearchSalesOfficesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchSalesOfficesQuery,
    SearchSalesOfficesQueryVariables
  >(SearchSalesOfficesDocument, options);
}
export function useSearchSalesOfficesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchSalesOfficesQuery,
    SearchSalesOfficesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchSalesOfficesQuery,
    SearchSalesOfficesQueryVariables
  >(SearchSalesOfficesDocument, options);
}
export function useSearchSalesOfficesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchSalesOfficesQuery,
        SearchSalesOfficesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchSalesOfficesQuery,
    SearchSalesOfficesQueryVariables
  >(SearchSalesOfficesDocument, options);
}
export type SearchSalesOfficesQueryHookResult = ReturnType<
  typeof useSearchSalesOfficesQuery
>;
export type SearchSalesOfficesLazyQueryHookResult = ReturnType<
  typeof useSearchSalesOfficesLazyQuery
>;
export type SearchSalesOfficesSuspenseQueryHookResult = ReturnType<
  typeof useSearchSalesOfficesSuspenseQuery
>;
export type SearchSalesOfficesQueryResult = Apollo.QueryResult<
  SearchSalesOfficesQuery,
  SearchSalesOfficesQueryVariables
>;
export const SearchSalesOfficesOnMasterDocument = gql`
  query searchSalesOfficesOnMaster(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: SalesOfficeQueryInput
    $order: [SalesOfficeOrderInput]
  ) {
    salesOffices: salesOffices(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          id
          groupID
          code
          name
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useSearchSalesOfficesOnMasterQuery__
 *
 * To run a query within a React component, call `useSearchSalesOfficesOnMasterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSalesOfficesOnMasterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSalesOfficesOnMasterQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchSalesOfficesOnMasterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchSalesOfficesOnMasterQuery,
    SearchSalesOfficesOnMasterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchSalesOfficesOnMasterQuery,
    SearchSalesOfficesOnMasterQueryVariables
  >(SearchSalesOfficesOnMasterDocument, options);
}
export function useSearchSalesOfficesOnMasterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchSalesOfficesOnMasterQuery,
    SearchSalesOfficesOnMasterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchSalesOfficesOnMasterQuery,
    SearchSalesOfficesOnMasterQueryVariables
  >(SearchSalesOfficesOnMasterDocument, options);
}
export function useSearchSalesOfficesOnMasterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchSalesOfficesOnMasterQuery,
        SearchSalesOfficesOnMasterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchSalesOfficesOnMasterQuery,
    SearchSalesOfficesOnMasterQueryVariables
  >(SearchSalesOfficesOnMasterDocument, options);
}
export type SearchSalesOfficesOnMasterQueryHookResult = ReturnType<
  typeof useSearchSalesOfficesOnMasterQuery
>;
export type SearchSalesOfficesOnMasterLazyQueryHookResult = ReturnType<
  typeof useSearchSalesOfficesOnMasterLazyQuery
>;
export type SearchSalesOfficesOnMasterSuspenseQueryHookResult = ReturnType<
  typeof useSearchSalesOfficesOnMasterSuspenseQuery
>;
export type SearchSalesOfficesOnMasterQueryResult = Apollo.QueryResult<
  SearchSalesOfficesOnMasterQuery,
  SearchSalesOfficesOnMasterQueryVariables
>;
export const FetchSalesOfficeDocument = gql`
  query fetchSalesOffice($id: ID!) {
    salesOffice(id: $id) {
      ...SalesOfficeItem
    }
  }
  ${SalesOfficeItemFragmentDoc}
`;

/**
 * __useFetchSalesOfficeQuery__
 *
 * To run a query within a React component, call `useFetchSalesOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSalesOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSalesOfficeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchSalesOfficeQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchSalesOfficeQuery,
    FetchSalesOfficeQueryVariables
  > &
    (
      | { variables: FetchSalesOfficeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchSalesOfficeQuery, FetchSalesOfficeQueryVariables>(
    FetchSalesOfficeDocument,
    options,
  );
}
export function useFetchSalesOfficeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchSalesOfficeQuery,
    FetchSalesOfficeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchSalesOfficeQuery,
    FetchSalesOfficeQueryVariables
  >(FetchSalesOfficeDocument, options);
}
export function useFetchSalesOfficeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchSalesOfficeQuery,
        FetchSalesOfficeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchSalesOfficeQuery,
    FetchSalesOfficeQueryVariables
  >(FetchSalesOfficeDocument, options);
}
export type FetchSalesOfficeQueryHookResult = ReturnType<
  typeof useFetchSalesOfficeQuery
>;
export type FetchSalesOfficeLazyQueryHookResult = ReturnType<
  typeof useFetchSalesOfficeLazyQuery
>;
export type FetchSalesOfficeSuspenseQueryHookResult = ReturnType<
  typeof useFetchSalesOfficeSuspenseQuery
>;
export type FetchSalesOfficeQueryResult = Apollo.QueryResult<
  FetchSalesOfficeQuery,
  FetchSalesOfficeQueryVariables
>;
export const UpdateSalesOfficeDocument = gql`
  mutation updateSalesOffice($id: ID!, $input: SalesOfficeUpdateInput!) {
    updateSalesOffice(id: $id, input: $input) {
      ...SalesOfficeItem
    }
  }
  ${SalesOfficeItemFragmentDoc}
`;
export type UpdateSalesOfficeMutationFn = Apollo.MutationFunction<
  UpdateSalesOfficeMutation,
  UpdateSalesOfficeMutationVariables
>;

/**
 * __useUpdateSalesOfficeMutation__
 *
 * To run a mutation, you first call `useUpdateSalesOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesOfficeMutation, { data, loading, error }] = useUpdateSalesOfficeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSalesOfficeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSalesOfficeMutation,
    UpdateSalesOfficeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSalesOfficeMutation,
    UpdateSalesOfficeMutationVariables
  >(UpdateSalesOfficeDocument, options);
}
export type UpdateSalesOfficeMutationHookResult = ReturnType<
  typeof useUpdateSalesOfficeMutation
>;
export type UpdateSalesOfficeMutationResult =
  Apollo.MutationResult<UpdateSalesOfficeMutation>;
export type UpdateSalesOfficeMutationOptions = Apollo.BaseMutationOptions<
  UpdateSalesOfficeMutation,
  UpdateSalesOfficeMutationVariables
>;
export const AddUserToSalesOfficeDocument = gql`
  mutation addUserToSalesOffice($input: AddUserToSalesOfficeInput!) {
    addUserToSalesOffice(input: $input)
  }
`;
export type AddUserToSalesOfficeMutationFn = Apollo.MutationFunction<
  AddUserToSalesOfficeMutation,
  AddUserToSalesOfficeMutationVariables
>;

/**
 * __useAddUserToSalesOfficeMutation__
 *
 * To run a mutation, you first call `useAddUserToSalesOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToSalesOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToSalesOfficeMutation, { data, loading, error }] = useAddUserToSalesOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToSalesOfficeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddUserToSalesOfficeMutation,
    AddUserToSalesOfficeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddUserToSalesOfficeMutation,
    AddUserToSalesOfficeMutationVariables
  >(AddUserToSalesOfficeDocument, options);
}
export type AddUserToSalesOfficeMutationHookResult = ReturnType<
  typeof useAddUserToSalesOfficeMutation
>;
export type AddUserToSalesOfficeMutationResult =
  Apollo.MutationResult<AddUserToSalesOfficeMutation>;
export type AddUserToSalesOfficeMutationOptions = Apollo.BaseMutationOptions<
  AddUserToSalesOfficeMutation,
  AddUserToSalesOfficeMutationVariables
>;
export const DelUserFromSalesOfficeDocument = gql`
  mutation delUserFromSalesOffice($input: DeleteUserFromSalesOfficeInput!) {
    deleteUserFromSalesOffice(input: $input)
  }
`;
export type DelUserFromSalesOfficeMutationFn = Apollo.MutationFunction<
  DelUserFromSalesOfficeMutation,
  DelUserFromSalesOfficeMutationVariables
>;

/**
 * __useDelUserFromSalesOfficeMutation__
 *
 * To run a mutation, you first call `useDelUserFromSalesOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelUserFromSalesOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delUserFromSalesOfficeMutation, { data, loading, error }] = useDelUserFromSalesOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDelUserFromSalesOfficeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DelUserFromSalesOfficeMutation,
    DelUserFromSalesOfficeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DelUserFromSalesOfficeMutation,
    DelUserFromSalesOfficeMutationVariables
  >(DelUserFromSalesOfficeDocument, options);
}
export type DelUserFromSalesOfficeMutationHookResult = ReturnType<
  typeof useDelUserFromSalesOfficeMutation
>;
export type DelUserFromSalesOfficeMutationResult =
  Apollo.MutationResult<DelUserFromSalesOfficeMutation>;
export type DelUserFromSalesOfficeMutationOptions = Apollo.BaseMutationOptions<
  DelUserFromSalesOfficeMutation,
  DelUserFromSalesOfficeMutationVariables
>;
export const SearchContractsDocument = gql`
  query searchContracts(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: ContractQueryInput
    $order: [ContractOrderInput]
  ) {
    contracts(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          id
          name
          workplaceName
          code
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useSearchContractsQuery__
 *
 * To run a query within a React component, call `useSearchContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContractsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchContractsQuery,
    SearchContractsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchContractsQuery, SearchContractsQueryVariables>(
    SearchContractsDocument,
    options,
  );
}
export function useSearchContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchContractsQuery,
    SearchContractsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchContractsQuery,
    SearchContractsQueryVariables
  >(SearchContractsDocument, options);
}
export function useSearchContractsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchContractsQuery,
        SearchContractsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchContractsQuery,
    SearchContractsQueryVariables
  >(SearchContractsDocument, options);
}
export type SearchContractsQueryHookResult = ReturnType<
  typeof useSearchContractsQuery
>;
export type SearchContractsLazyQueryHookResult = ReturnType<
  typeof useSearchContractsLazyQuery
>;
export type SearchContractsSuspenseQueryHookResult = ReturnType<
  typeof useSearchContractsSuspenseQuery
>;
export type SearchContractsQueryResult = Apollo.QueryResult<
  SearchContractsQuery,
  SearchContractsQueryVariables
>;
export const SearchContractsOnMasterDocument = gql`
  query searchContractsOnMaster(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: ContractQueryInput
    $order: [ContractOrderInput]
  ) {
    contracts(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          id
          name
          code
          workplaceName
          salesOffice {
            id
            name
            code
          }
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useSearchContractsOnMasterQuery__
 *
 * To run a query within a React component, call `useSearchContractsOnMasterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContractsOnMasterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContractsOnMasterQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchContractsOnMasterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchContractsOnMasterQuery,
    SearchContractsOnMasterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchContractsOnMasterQuery,
    SearchContractsOnMasterQueryVariables
  >(SearchContractsOnMasterDocument, options);
}
export function useSearchContractsOnMasterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchContractsOnMasterQuery,
    SearchContractsOnMasterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchContractsOnMasterQuery,
    SearchContractsOnMasterQueryVariables
  >(SearchContractsOnMasterDocument, options);
}
export function useSearchContractsOnMasterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchContractsOnMasterQuery,
        SearchContractsOnMasterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchContractsOnMasterQuery,
    SearchContractsOnMasterQueryVariables
  >(SearchContractsOnMasterDocument, options);
}
export type SearchContractsOnMasterQueryHookResult = ReturnType<
  typeof useSearchContractsOnMasterQuery
>;
export type SearchContractsOnMasterLazyQueryHookResult = ReturnType<
  typeof useSearchContractsOnMasterLazyQuery
>;
export type SearchContractsOnMasterSuspenseQueryHookResult = ReturnType<
  typeof useSearchContractsOnMasterSuspenseQuery
>;
export type SearchContractsOnMasterQueryResult = Apollo.QueryResult<
  SearchContractsOnMasterQuery,
  SearchContractsOnMasterQueryVariables
>;
export const FetchContractDocument = gql`
  query fetchContract($id: ID!) {
    contract(id: $id) {
      ...ContractDetailItem
    }
  }
  ${ContractDetailItemFragmentDoc}
`;

/**
 * __useFetchContractQuery__
 *
 * To run a query within a React component, call `useFetchContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchContractQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchContractQuery,
    FetchContractQueryVariables
  > &
    (
      | { variables: FetchContractQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchContractQuery, FetchContractQueryVariables>(
    FetchContractDocument,
    options,
  );
}
export function useFetchContractLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchContractQuery,
    FetchContractQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchContractQuery, FetchContractQueryVariables>(
    FetchContractDocument,
    options,
  );
}
export function useFetchContractSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchContractQuery,
        FetchContractQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchContractQuery,
    FetchContractQueryVariables
  >(FetchContractDocument, options);
}
export type FetchContractQueryHookResult = ReturnType<
  typeof useFetchContractQuery
>;
export type FetchContractLazyQueryHookResult = ReturnType<
  typeof useFetchContractLazyQuery
>;
export type FetchContractSuspenseQueryHookResult = ReturnType<
  typeof useFetchContractSuspenseQuery
>;
export type FetchContractQueryResult = Apollo.QueryResult<
  FetchContractQuery,
  FetchContractQueryVariables
>;
export const UpdateContractDocument = gql`
  mutation UpdateContract($id: ID!, $input: ContractUpdateInput!) {
    updateContract(id: $id, input: $input) {
      ...ContractDetailItem
    }
  }
  ${ContractDetailItemFragmentDoc}
`;
export type UpdateContractMutationFn = Apollo.MutationFunction<
  UpdateContractMutation,
  UpdateContractMutationVariables
>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContractMutation,
    UpdateContractMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContractMutation,
    UpdateContractMutationVariables
  >(UpdateContractDocument, options);
}
export type UpdateContractMutationHookResult = ReturnType<
  typeof useUpdateContractMutation
>;
export type UpdateContractMutationResult =
  Apollo.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<
  UpdateContractMutation,
  UpdateContractMutationVariables
>;
export const AddUserToContractDocument = gql`
  mutation addUserToContract($input: AddUserToContractInput!) {
    addUserToContract(input: $input)
  }
`;
export type AddUserToContractMutationFn = Apollo.MutationFunction<
  AddUserToContractMutation,
  AddUserToContractMutationVariables
>;

/**
 * __useAddUserToContractMutation__
 *
 * To run a mutation, you first call `useAddUserToContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToContractMutation, { data, loading, error }] = useAddUserToContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddUserToContractMutation,
    AddUserToContractMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddUserToContractMutation,
    AddUserToContractMutationVariables
  >(AddUserToContractDocument, options);
}
export type AddUserToContractMutationHookResult = ReturnType<
  typeof useAddUserToContractMutation
>;
export type AddUserToContractMutationResult =
  Apollo.MutationResult<AddUserToContractMutation>;
export type AddUserToContractMutationOptions = Apollo.BaseMutationOptions<
  AddUserToContractMutation,
  AddUserToContractMutationVariables
>;
export const DelUserFromContractDocument = gql`
  mutation delUserFromContract($input: DeleteUserFromContractInput!) {
    deleteUserFromContract(input: $input)
  }
`;
export type DelUserFromContractMutationFn = Apollo.MutationFunction<
  DelUserFromContractMutation,
  DelUserFromContractMutationVariables
>;

/**
 * __useDelUserFromContractMutation__
 *
 * To run a mutation, you first call `useDelUserFromContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelUserFromContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delUserFromContractMutation, { data, loading, error }] = useDelUserFromContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDelUserFromContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DelUserFromContractMutation,
    DelUserFromContractMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DelUserFromContractMutation,
    DelUserFromContractMutationVariables
  >(DelUserFromContractDocument, options);
}
export type DelUserFromContractMutationHookResult = ReturnType<
  typeof useDelUserFromContractMutation
>;
export type DelUserFromContractMutationResult =
  Apollo.MutationResult<DelUserFromContractMutation>;
export type DelUserFromContractMutationOptions = Apollo.BaseMutationOptions<
  DelUserFromContractMutation,
  DelUserFromContractMutationVariables
>;
export const FetchRecordTypesDocument = gql`
  query fetchRecordTypes($order: [RecordTypeOrderInput]) {
    recordTypes(order: $order) {
      edges {
        node {
          ...RecordTypeItem
        }
      }
    }
  }
  ${RecordTypeItemFragmentDoc}
`;

/**
 * __useFetchRecordTypesQuery__
 *
 * To run a query within a React component, call `useFetchRecordTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecordTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecordTypesQuery({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useFetchRecordTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchRecordTypesQuery,
    FetchRecordTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchRecordTypesQuery, FetchRecordTypesQueryVariables>(
    FetchRecordTypesDocument,
    options,
  );
}
export function useFetchRecordTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchRecordTypesQuery,
    FetchRecordTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchRecordTypesQuery,
    FetchRecordTypesQueryVariables
  >(FetchRecordTypesDocument, options);
}
export function useFetchRecordTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchRecordTypesQuery,
        FetchRecordTypesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchRecordTypesQuery,
    FetchRecordTypesQueryVariables
  >(FetchRecordTypesDocument, options);
}
export type FetchRecordTypesQueryHookResult = ReturnType<
  typeof useFetchRecordTypesQuery
>;
export type FetchRecordTypesLazyQueryHookResult = ReturnType<
  typeof useFetchRecordTypesLazyQuery
>;
export type FetchRecordTypesSuspenseQueryHookResult = ReturnType<
  typeof useFetchRecordTypesSuspenseQuery
>;
export type FetchRecordTypesQueryResult = Apollo.QueryResult<
  FetchRecordTypesQuery,
  FetchRecordTypesQueryVariables
>;
export const SearchApplicationDatesDocument = gql`
  query searchApplicationDates($query: WorkRecordQueryInput) {
    workRecords(query: $query) {
      edges {
        node {
          applicationDate
        }
      }
    }
  }
`;

/**
 * __useSearchApplicationDatesQuery__
 *
 * To run a query within a React component, call `useSearchApplicationDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchApplicationDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchApplicationDatesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchApplicationDatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchApplicationDatesQuery,
    SearchApplicationDatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchApplicationDatesQuery,
    SearchApplicationDatesQueryVariables
  >(SearchApplicationDatesDocument, options);
}
export function useSearchApplicationDatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchApplicationDatesQuery,
    SearchApplicationDatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchApplicationDatesQuery,
    SearchApplicationDatesQueryVariables
  >(SearchApplicationDatesDocument, options);
}
export function useSearchApplicationDatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchApplicationDatesQuery,
        SearchApplicationDatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchApplicationDatesQuery,
    SearchApplicationDatesQueryVariables
  >(SearchApplicationDatesDocument, options);
}
export type SearchApplicationDatesQueryHookResult = ReturnType<
  typeof useSearchApplicationDatesQuery
>;
export type SearchApplicationDatesLazyQueryHookResult = ReturnType<
  typeof useSearchApplicationDatesLazyQuery
>;
export type SearchApplicationDatesSuspenseQueryHookResult = ReturnType<
  typeof useSearchApplicationDatesSuspenseQuery
>;
export type SearchApplicationDatesQueryResult = Apollo.QueryResult<
  SearchApplicationDatesQuery,
  SearchApplicationDatesQueryVariables
>;
export const SearchWorkRecordsDocument = gql`
  query searchWorkRecords(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: WorkRecordQueryInput
    $order: [WorkRecordOrderInput]
  ) {
    workRecords(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          ...WorkRecordItem
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
  ${WorkRecordItemFragmentDoc}
`;

/**
 * __useSearchWorkRecordsQuery__
 *
 * To run a query within a React component, call `useSearchWorkRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWorkRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWorkRecordsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchWorkRecordsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchWorkRecordsQuery,
    SearchWorkRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchWorkRecordsQuery,
    SearchWorkRecordsQueryVariables
  >(SearchWorkRecordsDocument, options);
}
export function useSearchWorkRecordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchWorkRecordsQuery,
    SearchWorkRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchWorkRecordsQuery,
    SearchWorkRecordsQueryVariables
  >(SearchWorkRecordsDocument, options);
}
export function useSearchWorkRecordsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchWorkRecordsQuery,
        SearchWorkRecordsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchWorkRecordsQuery,
    SearchWorkRecordsQueryVariables
  >(SearchWorkRecordsDocument, options);
}
export type SearchWorkRecordsQueryHookResult = ReturnType<
  typeof useSearchWorkRecordsQuery
>;
export type SearchWorkRecordsLazyQueryHookResult = ReturnType<
  typeof useSearchWorkRecordsLazyQuery
>;
export type SearchWorkRecordsSuspenseQueryHookResult = ReturnType<
  typeof useSearchWorkRecordsSuspenseQuery
>;
export type SearchWorkRecordsQueryResult = Apollo.QueryResult<
  SearchWorkRecordsQuery,
  SearchWorkRecordsQueryVariables
>;
export const SearchDeletedWorkRecordsDocument = gql`
  query searchDeletedWorkRecords(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: DeletedWorkRecordQueryInput
    $order: [DeletedWorkRecordOrderInput]
  ) {
    deletedWorkRecords(
      first: $first
      after: $after
      last: $last
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          ...DeletedWorkRecordItem
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
  ${DeletedWorkRecordItemFragmentDoc}
`;

/**
 * __useSearchDeletedWorkRecordsQuery__
 *
 * To run a query within a React component, call `useSearchDeletedWorkRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDeletedWorkRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDeletedWorkRecordsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchDeletedWorkRecordsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchDeletedWorkRecordsQuery,
    SearchDeletedWorkRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchDeletedWorkRecordsQuery,
    SearchDeletedWorkRecordsQueryVariables
  >(SearchDeletedWorkRecordsDocument, options);
}
export function useSearchDeletedWorkRecordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchDeletedWorkRecordsQuery,
    SearchDeletedWorkRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchDeletedWorkRecordsQuery,
    SearchDeletedWorkRecordsQueryVariables
  >(SearchDeletedWorkRecordsDocument, options);
}
export function useSearchDeletedWorkRecordsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchDeletedWorkRecordsQuery,
        SearchDeletedWorkRecordsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchDeletedWorkRecordsQuery,
    SearchDeletedWorkRecordsQueryVariables
  >(SearchDeletedWorkRecordsDocument, options);
}
export type SearchDeletedWorkRecordsQueryHookResult = ReturnType<
  typeof useSearchDeletedWorkRecordsQuery
>;
export type SearchDeletedWorkRecordsLazyQueryHookResult = ReturnType<
  typeof useSearchDeletedWorkRecordsLazyQuery
>;
export type SearchDeletedWorkRecordsSuspenseQueryHookResult = ReturnType<
  typeof useSearchDeletedWorkRecordsSuspenseQuery
>;
export type SearchDeletedWorkRecordsQueryResult = Apollo.QueryResult<
  SearchDeletedWorkRecordsQuery,
  SearchDeletedWorkRecordsQueryVariables
>;
export const ApplyWorkRecordDocument = gql`
  mutation applyWorkRecord($input: ApplyWorkRecordInput!) {
    applyWorkRecord(input: $input)
  }
`;
export type ApplyWorkRecordMutationFn = Apollo.MutationFunction<
  ApplyWorkRecordMutation,
  ApplyWorkRecordMutationVariables
>;

/**
 * __useApplyWorkRecordMutation__
 *
 * To run a mutation, you first call `useApplyWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyWorkRecordMutation, { data, loading, error }] = useApplyWorkRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyWorkRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyWorkRecordMutation,
    ApplyWorkRecordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyWorkRecordMutation,
    ApplyWorkRecordMutationVariables
  >(ApplyWorkRecordDocument, options);
}
export type ApplyWorkRecordMutationHookResult = ReturnType<
  typeof useApplyWorkRecordMutation
>;
export type ApplyWorkRecordMutationResult =
  Apollo.MutationResult<ApplyWorkRecordMutation>;
export type ApplyWorkRecordMutationOptions = Apollo.BaseMutationOptions<
  ApplyWorkRecordMutation,
  ApplyWorkRecordMutationVariables
>;
export const UpdateWorkRecordDocument = gql`
  mutation updateWorkRecord($input: EditWorkRecordInput!) {
    editWorkRecord(input: $input)
  }
`;
export type UpdateWorkRecordMutationFn = Apollo.MutationFunction<
  UpdateWorkRecordMutation,
  UpdateWorkRecordMutationVariables
>;

/**
 * __useUpdateWorkRecordMutation__
 *
 * To run a mutation, you first call `useUpdateWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkRecordMutation, { data, loading, error }] = useUpdateWorkRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkRecordMutation,
    UpdateWorkRecordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkRecordMutation,
    UpdateWorkRecordMutationVariables
  >(UpdateWorkRecordDocument, options);
}
export type UpdateWorkRecordMutationHookResult = ReturnType<
  typeof useUpdateWorkRecordMutation
>;
export type UpdateWorkRecordMutationResult =
  Apollo.MutationResult<UpdateWorkRecordMutation>;
export type UpdateWorkRecordMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkRecordMutation,
  UpdateWorkRecordMutationVariables
>;
export const ApproveWorkRecordDocument = gql`
  mutation approveWorkRecord($id: ID!, $action: String!) {
    punchWorkRecord(id: $id, action: $action) {
      id
      currentState
    }
  }
`;
export type ApproveWorkRecordMutationFn = Apollo.MutationFunction<
  ApproveWorkRecordMutation,
  ApproveWorkRecordMutationVariables
>;

/**
 * __useApproveWorkRecordMutation__
 *
 * To run a mutation, you first call `useApproveWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveWorkRecordMutation, { data, loading, error }] = useApproveWorkRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useApproveWorkRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveWorkRecordMutation,
    ApproveWorkRecordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveWorkRecordMutation,
    ApproveWorkRecordMutationVariables
  >(ApproveWorkRecordDocument, options);
}
export type ApproveWorkRecordMutationHookResult = ReturnType<
  typeof useApproveWorkRecordMutation
>;
export type ApproveWorkRecordMutationResult =
  Apollo.MutationResult<ApproveWorkRecordMutation>;
export type ApproveWorkRecordMutationOptions = Apollo.BaseMutationOptions<
  ApproveWorkRecordMutation,
  ApproveWorkRecordMutationVariables
>;
export const MeForProfileDocument = gql`
  query meForProfile {
    me {
      ...Profile
    }
  }
  ${ProfileFragmentDoc}
`;

/**
 * __useMeForProfileQuery__
 *
 * To run a query within a React component, call `useMeForProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeForProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeForProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeForProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MeForProfileQuery,
    MeForProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeForProfileQuery, MeForProfileQueryVariables>(
    MeForProfileDocument,
    options,
  );
}
export function useMeForProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MeForProfileQuery,
    MeForProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeForProfileQuery, MeForProfileQueryVariables>(
    MeForProfileDocument,
    options,
  );
}
export function useMeForProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeForProfileQuery,
        MeForProfileQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MeForProfileQuery, MeForProfileQueryVariables>(
    MeForProfileDocument,
    options,
  );
}
export type MeForProfileQueryHookResult = ReturnType<
  typeof useMeForProfileQuery
>;
export type MeForProfileLazyQueryHookResult = ReturnType<
  typeof useMeForProfileLazyQuery
>;
export type MeForProfileSuspenseQueryHookResult = ReturnType<
  typeof useMeForProfileSuspenseQuery
>;
export type MeForProfileQueryResult = Apollo.QueryResult<
  MeForProfileQuery,
  MeForProfileQueryVariables
>;
export const GetUserDocument = gql`
  query getUser($id: ID!) {
    user(id: $id) {
      id
      username
      displayName
      groups
      roles
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> &
    ({ variables: GetUserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options,
  );
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserQuery,
    GetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options,
  );
}
export function useGetUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options,
  );
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<
  typeof useGetUserSuspenseQuery
>;
export type GetUserQueryResult = Apollo.QueryResult<
  GetUserQuery,
  GetUserQueryVariables
>;
export const FetchRolesDocument = gql`
  query fetchRoles(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: RoleQueryInput
    $order: [RoleOrderInput]
  ) {
    roles(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          name
          roleClass {
            id
            name
          }
          roleClassID
        }
      }
    }
  }
`;

/**
 * __useFetchRolesQuery__
 *
 * To run a query within a React component, call `useFetchRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRolesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useFetchRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchRolesQuery,
    FetchRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchRolesQuery, FetchRolesQueryVariables>(
    FetchRolesDocument,
    options,
  );
}
export function useFetchRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchRolesQuery,
    FetchRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchRolesQuery, FetchRolesQueryVariables>(
    FetchRolesDocument,
    options,
  );
}
export function useFetchRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchRolesQuery,
        FetchRolesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FetchRolesQuery, FetchRolesQueryVariables>(
    FetchRolesDocument,
    options,
  );
}
export type FetchRolesQueryHookResult = ReturnType<typeof useFetchRolesQuery>;
export type FetchRolesLazyQueryHookResult = ReturnType<
  typeof useFetchRolesLazyQuery
>;
export type FetchRolesSuspenseQueryHookResult = ReturnType<
  typeof useFetchRolesSuspenseQuery
>;
export type FetchRolesQueryResult = Apollo.QueryResult<
  FetchRolesQuery,
  FetchRolesQueryVariables
>;
export const FetchGroupsDocument = gql`
  query fetchGroups(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: GroupQueryInput
    $order: [GroupOrderInput]
  ) {
    groups(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          name
          code
          parent {
            id
            name
            code
          }
          parentId
        }
      }
    }
  }
`;

/**
 * __useFetchGroupsQuery__
 *
 * To run a query within a React component, call `useFetchGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useFetchGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchGroupsQuery,
    FetchGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchGroupsQuery, FetchGroupsQueryVariables>(
    FetchGroupsDocument,
    options,
  );
}
export function useFetchGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchGroupsQuery,
    FetchGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchGroupsQuery, FetchGroupsQueryVariables>(
    FetchGroupsDocument,
    options,
  );
}
export function useFetchGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchGroupsQuery,
        FetchGroupsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FetchGroupsQuery, FetchGroupsQueryVariables>(
    FetchGroupsDocument,
    options,
  );
}
export type FetchGroupsQueryHookResult = ReturnType<typeof useFetchGroupsQuery>;
export type FetchGroupsLazyQueryHookResult = ReturnType<
  typeof useFetchGroupsLazyQuery
>;
export type FetchGroupsSuspenseQueryHookResult = ReturnType<
  typeof useFetchGroupsSuspenseQuery
>;
export type FetchGroupsQueryResult = Apollo.QueryResult<
  FetchGroupsQuery,
  FetchGroupsQueryVariables
>;
export const FetchEmployeeByUserIdDocument = gql`
  query fetchEmployeeByUserId($id: ID!) {
    employees(query: { userID: { eq: $id } }, first: 1) {
      edges {
        node {
          ...EmployeeItem
        }
      }
    }
  }
  ${EmployeeItemFragmentDoc}
`;

/**
 * __useFetchEmployeeByUserIdQuery__
 *
 * To run a query within a React component, call `useFetchEmployeeByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeeByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchEmployeeByUserIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchEmployeeByUserIdQuery,
    FetchEmployeeByUserIdQueryVariables
  > &
    (
      | { variables: FetchEmployeeByUserIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchEmployeeByUserIdQuery,
    FetchEmployeeByUserIdQueryVariables
  >(FetchEmployeeByUserIdDocument, options);
}
export function useFetchEmployeeByUserIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchEmployeeByUserIdQuery,
    FetchEmployeeByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchEmployeeByUserIdQuery,
    FetchEmployeeByUserIdQueryVariables
  >(FetchEmployeeByUserIdDocument, options);
}
export function useFetchEmployeeByUserIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchEmployeeByUserIdQuery,
        FetchEmployeeByUserIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchEmployeeByUserIdQuery,
    FetchEmployeeByUserIdQueryVariables
  >(FetchEmployeeByUserIdDocument, options);
}
export type FetchEmployeeByUserIdQueryHookResult = ReturnType<
  typeof useFetchEmployeeByUserIdQuery
>;
export type FetchEmployeeByUserIdLazyQueryHookResult = ReturnType<
  typeof useFetchEmployeeByUserIdLazyQuery
>;
export type FetchEmployeeByUserIdSuspenseQueryHookResult = ReturnType<
  typeof useFetchEmployeeByUserIdSuspenseQuery
>;
export type FetchEmployeeByUserIdQueryResult = Apollo.QueryResult<
  FetchEmployeeByUserIdQuery,
  FetchEmployeeByUserIdQueryVariables
>;
export const FetchEmployeeDocument = gql`
  query fetchEmployee($id: ID!) {
    employee(id: $id) {
      ...EmployeeItem
    }
  }
  ${EmployeeItemFragmentDoc}
`;

/**
 * __useFetchEmployeeQuery__
 *
 * To run a query within a React component, call `useFetchEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchEmployeeQuery,
    FetchEmployeeQueryVariables
  > &
    (
      | { variables: FetchEmployeeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchEmployeeQuery, FetchEmployeeQueryVariables>(
    FetchEmployeeDocument,
    options,
  );
}
export function useFetchEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchEmployeeQuery,
    FetchEmployeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchEmployeeQuery, FetchEmployeeQueryVariables>(
    FetchEmployeeDocument,
    options,
  );
}
export function useFetchEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchEmployeeQuery,
        FetchEmployeeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchEmployeeQuery,
    FetchEmployeeQueryVariables
  >(FetchEmployeeDocument, options);
}
export type FetchEmployeeQueryHookResult = ReturnType<
  typeof useFetchEmployeeQuery
>;
export type FetchEmployeeLazyQueryHookResult = ReturnType<
  typeof useFetchEmployeeLazyQuery
>;
export type FetchEmployeeSuspenseQueryHookResult = ReturnType<
  typeof useFetchEmployeeSuspenseQuery
>;
export type FetchEmployeeQueryResult = Apollo.QueryResult<
  FetchEmployeeQuery,
  FetchEmployeeQueryVariables
>;
export const SearchEmployeesDocument = gql`
  query searchEmployees(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: EmployeeQueryInput
    $order: [EmployeeOrderInput]
  ) {
    employees(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          ...EmployeeItem
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
  ${EmployeeItemFragmentDoc}
`;

/**
 * __useSearchEmployeesQuery__
 *
 * To run a query within a React component, call `useSearchEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmployeesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchEmployeesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchEmployeesQuery,
    SearchEmployeesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchEmployeesQuery, SearchEmployeesQueryVariables>(
    SearchEmployeesDocument,
    options,
  );
}
export function useSearchEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchEmployeesQuery,
    SearchEmployeesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchEmployeesQuery,
    SearchEmployeesQueryVariables
  >(SearchEmployeesDocument, options);
}
export function useSearchEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchEmployeesQuery,
        SearchEmployeesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchEmployeesQuery,
    SearchEmployeesQueryVariables
  >(SearchEmployeesDocument, options);
}
export type SearchEmployeesQueryHookResult = ReturnType<
  typeof useSearchEmployeesQuery
>;
export type SearchEmployeesLazyQueryHookResult = ReturnType<
  typeof useSearchEmployeesLazyQuery
>;
export type SearchEmployeesSuspenseQueryHookResult = ReturnType<
  typeof useSearchEmployeesSuspenseQuery
>;
export type SearchEmployeesQueryResult = Apollo.QueryResult<
  SearchEmployeesQuery,
  SearchEmployeesQueryVariables
>;
export const UpdateEmployeeDocument = gql`
  mutation updateEmployee($id: ID!, $input: EmployeeUpdateInput!) {
    updateEmployee(id: $id, input: $input) {
      id
    }
  }
`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<
  UpdateEmployeeMutation,
  UpdateEmployeeMutationVariables
>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmployeeMutation,
    UpdateEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEmployeeMutation,
    UpdateEmployeeMutationVariables
  >(UpdateEmployeeDocument, options);
}
export type UpdateEmployeeMutationHookResult = ReturnType<
  typeof useUpdateEmployeeMutation
>;
export type UpdateEmployeeMutationResult =
  Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmployeeMutation,
  UpdateEmployeeMutationVariables
>;
export const MoveWorkrecordToDeletedWorkrecordDocument = gql`
  mutation moveWorkrecordToDeletedWorkrecord(
    $currentState: String!
    $deleteReason: String
    $deletedDate: Date!
    $id: ID!
  ) {
    moveToDeletedWorkrecord(
      input: {
        currentState: $currentState
        deleteReason: $deleteReason
        deletedDate: $deletedDate
        id: $id
      }
    )
  }
`;
export type MoveWorkrecordToDeletedWorkrecordMutationFn =
  Apollo.MutationFunction<
    MoveWorkrecordToDeletedWorkrecordMutation,
    MoveWorkrecordToDeletedWorkrecordMutationVariables
  >;

/**
 * __useMoveWorkrecordToDeletedWorkrecordMutation__
 *
 * To run a mutation, you first call `useMoveWorkrecordToDeletedWorkrecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveWorkrecordToDeletedWorkrecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveWorkrecordToDeletedWorkrecordMutation, { data, loading, error }] = useMoveWorkrecordToDeletedWorkrecordMutation({
 *   variables: {
 *      currentState: // value for 'currentState'
 *      deleteReason: // value for 'deleteReason'
 *      deletedDate: // value for 'deletedDate'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMoveWorkrecordToDeletedWorkrecordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoveWorkrecordToDeletedWorkrecordMutation,
    MoveWorkrecordToDeletedWorkrecordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MoveWorkrecordToDeletedWorkrecordMutation,
    MoveWorkrecordToDeletedWorkrecordMutationVariables
  >(MoveWorkrecordToDeletedWorkrecordDocument, options);
}
export type MoveWorkrecordToDeletedWorkrecordMutationHookResult = ReturnType<
  typeof useMoveWorkrecordToDeletedWorkrecordMutation
>;
export type MoveWorkrecordToDeletedWorkrecordMutationResult =
  Apollo.MutationResult<MoveWorkrecordToDeletedWorkrecordMutation>;
export type MoveWorkrecordToDeletedWorkrecordMutationOptions =
  Apollo.BaseMutationOptions<
    MoveWorkrecordToDeletedWorkrecordMutation,
    MoveWorkrecordToDeletedWorkrecordMutationVariables
  >;
export const SettingEmployeeWorkingTimesDocument = gql`
  query settingEmployeeWorkingTimes(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: EmployeeWorkingTimeQueryInput
    $order: [EmployeeWorkingTimeOrderInput]
  ) {
    employeeWorkingTimes(
      first: $first
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          ...EmployeeWorkingTimeItem
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
  ${EmployeeWorkingTimeItemFragmentDoc}
`;

/**
 * __useSettingEmployeeWorkingTimesQuery__
 *
 * To run a query within a React component, call `useSettingEmployeeWorkingTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingEmployeeWorkingTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingEmployeeWorkingTimesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSettingEmployeeWorkingTimesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SettingEmployeeWorkingTimesQuery,
    SettingEmployeeWorkingTimesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SettingEmployeeWorkingTimesQuery,
    SettingEmployeeWorkingTimesQueryVariables
  >(SettingEmployeeWorkingTimesDocument, options);
}
export function useSettingEmployeeWorkingTimesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SettingEmployeeWorkingTimesQuery,
    SettingEmployeeWorkingTimesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SettingEmployeeWorkingTimesQuery,
    SettingEmployeeWorkingTimesQueryVariables
  >(SettingEmployeeWorkingTimesDocument, options);
}
export function useSettingEmployeeWorkingTimesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SettingEmployeeWorkingTimesQuery,
        SettingEmployeeWorkingTimesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SettingEmployeeWorkingTimesQuery,
    SettingEmployeeWorkingTimesQueryVariables
  >(SettingEmployeeWorkingTimesDocument, options);
}
export type SettingEmployeeWorkingTimesQueryHookResult = ReturnType<
  typeof useSettingEmployeeWorkingTimesQuery
>;
export type SettingEmployeeWorkingTimesLazyQueryHookResult = ReturnType<
  typeof useSettingEmployeeWorkingTimesLazyQuery
>;
export type SettingEmployeeWorkingTimesSuspenseQueryHookResult = ReturnType<
  typeof useSettingEmployeeWorkingTimesSuspenseQuery
>;
export type SettingEmployeeWorkingTimesQueryResult = Apollo.QueryResult<
  SettingEmployeeWorkingTimesQuery,
  SettingEmployeeWorkingTimesQueryVariables
>;
export const EditSettingEmployeeWorkingTimeDocument = gql`
  mutation editSettingEmployeeWorkingTime(
    $input: EditEmployeeWorkingTimeInput!
  ) {
    editEmployeeWorkingTime(input: $input)
  }
`;
export type EditSettingEmployeeWorkingTimeMutationFn = Apollo.MutationFunction<
  EditSettingEmployeeWorkingTimeMutation,
  EditSettingEmployeeWorkingTimeMutationVariables
>;

/**
 * __useEditSettingEmployeeWorkingTimeMutation__
 *
 * To run a mutation, you first call `useEditSettingEmployeeWorkingTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSettingEmployeeWorkingTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSettingEmployeeWorkingTimeMutation, { data, loading, error }] = useEditSettingEmployeeWorkingTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSettingEmployeeWorkingTimeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditSettingEmployeeWorkingTimeMutation,
    EditSettingEmployeeWorkingTimeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditSettingEmployeeWorkingTimeMutation,
    EditSettingEmployeeWorkingTimeMutationVariables
  >(EditSettingEmployeeWorkingTimeDocument, options);
}
export type EditSettingEmployeeWorkingTimeMutationHookResult = ReturnType<
  typeof useEditSettingEmployeeWorkingTimeMutation
>;
export type EditSettingEmployeeWorkingTimeMutationResult =
  Apollo.MutationResult<EditSettingEmployeeWorkingTimeMutation>;
export type EditSettingEmployeeWorkingTimeMutationOptions =
  Apollo.BaseMutationOptions<
    EditSettingEmployeeWorkingTimeMutation,
    EditSettingEmployeeWorkingTimeMutationVariables
  >;
export const AddSettingEmployeeWorkingTimeDocument = gql`
  mutation addSettingEmployeeWorkingTime($input: AddEmployeeWorkingTimeInput!) {
    addEmployeeWorkingTime(input: $input)
  }
`;
export type AddSettingEmployeeWorkingTimeMutationFn = Apollo.MutationFunction<
  AddSettingEmployeeWorkingTimeMutation,
  AddSettingEmployeeWorkingTimeMutationVariables
>;

/**
 * __useAddSettingEmployeeWorkingTimeMutation__
 *
 * To run a mutation, you first call `useAddSettingEmployeeWorkingTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSettingEmployeeWorkingTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSettingEmployeeWorkingTimeMutation, { data, loading, error }] = useAddSettingEmployeeWorkingTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSettingEmployeeWorkingTimeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSettingEmployeeWorkingTimeMutation,
    AddSettingEmployeeWorkingTimeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSettingEmployeeWorkingTimeMutation,
    AddSettingEmployeeWorkingTimeMutationVariables
  >(AddSettingEmployeeWorkingTimeDocument, options);
}
export type AddSettingEmployeeWorkingTimeMutationHookResult = ReturnType<
  typeof useAddSettingEmployeeWorkingTimeMutation
>;
export type AddSettingEmployeeWorkingTimeMutationResult =
  Apollo.MutationResult<AddSettingEmployeeWorkingTimeMutation>;
export type AddSettingEmployeeWorkingTimeMutationOptions =
  Apollo.BaseMutationOptions<
    AddSettingEmployeeWorkingTimeMutation,
    AddSettingEmployeeWorkingTimeMutationVariables
  >;
export const DeleteSettingEmployeeWorkingTimeDocument = gql`
  mutation deleteSettingEmployeeWorkingTime($id: ID!) {
    deleteEmployeeWorkingTime(id: $id)
  }
`;
export type DeleteSettingEmployeeWorkingTimeMutationFn =
  Apollo.MutationFunction<
    DeleteSettingEmployeeWorkingTimeMutation,
    DeleteSettingEmployeeWorkingTimeMutationVariables
  >;

/**
 * __useDeleteSettingEmployeeWorkingTimeMutation__
 *
 * To run a mutation, you first call `useDeleteSettingEmployeeWorkingTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSettingEmployeeWorkingTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSettingEmployeeWorkingTimeMutation, { data, loading, error }] = useDeleteSettingEmployeeWorkingTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSettingEmployeeWorkingTimeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSettingEmployeeWorkingTimeMutation,
    DeleteSettingEmployeeWorkingTimeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSettingEmployeeWorkingTimeMutation,
    DeleteSettingEmployeeWorkingTimeMutationVariables
  >(DeleteSettingEmployeeWorkingTimeDocument, options);
}
export type DeleteSettingEmployeeWorkingTimeMutationHookResult = ReturnType<
  typeof useDeleteSettingEmployeeWorkingTimeMutation
>;
export type DeleteSettingEmployeeWorkingTimeMutationResult =
  Apollo.MutationResult<DeleteSettingEmployeeWorkingTimeMutation>;
export type DeleteSettingEmployeeWorkingTimeMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteSettingEmployeeWorkingTimeMutation,
    DeleteSettingEmployeeWorkingTimeMutationVariables
  >;
export const ContractSummariesDocument = gql`
  query contractSummaries($input: ContractSummariesInput) {
    contractSummaries(input: $input) {
      total
      collection {
        contract {
          id
          name
          workplaceName
          code
          salesOffice {
            name
          }
        }
        workRecordSummaries {
          collection {
            currentState
            count
          }
          holidayCount
        }
      }
    }
  }
`;

/**
 * __useContractSummariesQuery__
 *
 * To run a query within a React component, call `useContractSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractSummariesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractSummariesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContractSummariesQuery,
    ContractSummariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ContractSummariesQuery,
    ContractSummariesQueryVariables
  >(ContractSummariesDocument, options);
}
export function useContractSummariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContractSummariesQuery,
    ContractSummariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ContractSummariesQuery,
    ContractSummariesQueryVariables
  >(ContractSummariesDocument, options);
}
export function useContractSummariesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContractSummariesQuery,
        ContractSummariesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ContractSummariesQuery,
    ContractSummariesQueryVariables
  >(ContractSummariesDocument, options);
}
export type ContractSummariesQueryHookResult = ReturnType<
  typeof useContractSummariesQuery
>;
export type ContractSummariesLazyQueryHookResult = ReturnType<
  typeof useContractSummariesLazyQuery
>;
export type ContractSummariesSuspenseQueryHookResult = ReturnType<
  typeof useContractSummariesSuspenseQuery
>;
export type ContractSummariesQueryResult = Apollo.QueryResult<
  ContractSummariesQuery,
  ContractSummariesQueryVariables
>;
export const EmployeeSummariesDocument = gql`
  query employeeSummaries($input: EmployeeSummariesInput) {
    employeeSummaries(input: $input) {
      total
      collection {
        employee {
          id
          name
          code
        }
        workRecordSummaries {
          collection {
            currentState
            count
          }
          holidayCount
        }
      }
    }
  }
`;

/**
 * __useEmployeeSummariesQuery__
 *
 * To run a query within a React component, call `useEmployeeSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeSummariesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeSummariesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EmployeeSummariesQuery,
    EmployeeSummariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EmployeeSummariesQuery,
    EmployeeSummariesQueryVariables
  >(EmployeeSummariesDocument, options);
}
export function useEmployeeSummariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmployeeSummariesQuery,
    EmployeeSummariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EmployeeSummariesQuery,
    EmployeeSummariesQueryVariables
  >(EmployeeSummariesDocument, options);
}
export function useEmployeeSummariesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EmployeeSummariesQuery,
        EmployeeSummariesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EmployeeSummariesQuery,
    EmployeeSummariesQueryVariables
  >(EmployeeSummariesDocument, options);
}
export type EmployeeSummariesQueryHookResult = ReturnType<
  typeof useEmployeeSummariesQuery
>;
export type EmployeeSummariesLazyQueryHookResult = ReturnType<
  typeof useEmployeeSummariesLazyQuery
>;
export type EmployeeSummariesSuspenseQueryHookResult = ReturnType<
  typeof useEmployeeSummariesSuspenseQuery
>;
export type EmployeeSummariesQueryResult = Apollo.QueryResult<
  EmployeeSummariesQuery,
  EmployeeSummariesQueryVariables
>;
export const CloseMonthDocument = gql`
  mutation closeMonth($input: CloseMonthInput!) {
    closeMonth(input: $input)
  }
`;
export type CloseMonthMutationFn = Apollo.MutationFunction<
  CloseMonthMutation,
  CloseMonthMutationVariables
>;

/**
 * __useCloseMonthMutation__
 *
 * To run a mutation, you first call `useCloseMonthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseMonthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeMonthMutation, { data, loading, error }] = useCloseMonthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseMonthMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloseMonthMutation,
    CloseMonthMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseMonthMutation, CloseMonthMutationVariables>(
    CloseMonthDocument,
    options,
  );
}
export type CloseMonthMutationHookResult = ReturnType<
  typeof useCloseMonthMutation
>;
export type CloseMonthMutationResult =
  Apollo.MutationResult<CloseMonthMutation>;
export type CloseMonthMutationOptions = Apollo.BaseMutationOptions<
  CloseMonthMutation,
  CloseMonthMutationVariables
>;
export const FetchEmployeeCategoriesDocument = gql`
  query fetchEmployeeCategories {
    employeeCategories {
      edges {
        node {
          id
          name
          code
        }
      }
    }
  }
`;

/**
 * __useFetchEmployeeCategoriesQuery__
 *
 * To run a query within a React component, call `useFetchEmployeeCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeeCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchEmployeeCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchEmployeeCategoriesQuery,
    FetchEmployeeCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchEmployeeCategoriesQuery,
    FetchEmployeeCategoriesQueryVariables
  >(FetchEmployeeCategoriesDocument, options);
}
export function useFetchEmployeeCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchEmployeeCategoriesQuery,
    FetchEmployeeCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchEmployeeCategoriesQuery,
    FetchEmployeeCategoriesQueryVariables
  >(FetchEmployeeCategoriesDocument, options);
}
export function useFetchEmployeeCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchEmployeeCategoriesQuery,
        FetchEmployeeCategoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchEmployeeCategoriesQuery,
    FetchEmployeeCategoriesQueryVariables
  >(FetchEmployeeCategoriesDocument, options);
}
export type FetchEmployeeCategoriesQueryHookResult = ReturnType<
  typeof useFetchEmployeeCategoriesQuery
>;
export type FetchEmployeeCategoriesLazyQueryHookResult = ReturnType<
  typeof useFetchEmployeeCategoriesLazyQuery
>;
export type FetchEmployeeCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useFetchEmployeeCategoriesSuspenseQuery
>;
export type FetchEmployeeCategoriesQueryResult = Apollo.QueryResult<
  FetchEmployeeCategoriesQuery,
  FetchEmployeeCategoriesQueryVariables
>;
export const HolidayRecordDocument = gql`
  query HolidayRecord {
    recordTypes(query: { name: { eq: "休日" } }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useHolidayRecordQuery__
 *
 * To run a query within a React component, call `useHolidayRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useHolidayRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHolidayRecordQuery({
 *   variables: {
 *   },
 * });
 */
export function useHolidayRecordQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HolidayRecordQuery,
    HolidayRecordQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HolidayRecordQuery, HolidayRecordQueryVariables>(
    HolidayRecordDocument,
    options,
  );
}
export function useHolidayRecordLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HolidayRecordQuery,
    HolidayRecordQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HolidayRecordQuery, HolidayRecordQueryVariables>(
    HolidayRecordDocument,
    options,
  );
}
export function useHolidayRecordSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HolidayRecordQuery,
        HolidayRecordQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HolidayRecordQuery,
    HolidayRecordQueryVariables
  >(HolidayRecordDocument, options);
}
export type HolidayRecordQueryHookResult = ReturnType<
  typeof useHolidayRecordQuery
>;
export type HolidayRecordLazyQueryHookResult = ReturnType<
  typeof useHolidayRecordLazyQuery
>;
export type HolidayRecordSuspenseQueryHookResult = ReturnType<
  typeof useHolidayRecordSuspenseQuery
>;
export type HolidayRecordQueryResult = Apollo.QueryResult<
  HolidayRecordQuery,
  HolidayRecordQueryVariables
>;
export const CloseStatusesDocument = gql`
  query CloseStatuses($query: CloseStatusQueryInput) {
    closeStatuses(query: $query) {
      total
      edges {
        node {
          status
          id
          contractID
          closeDate
          updatedByID
          executedAt
          executedById
        }
      }
    }
  }
`;

/**
 * __useCloseStatusesQuery__
 *
 * To run a query within a React component, call `useCloseStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloseStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloseStatusesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCloseStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CloseStatusesQuery,
    CloseStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CloseStatusesQuery, CloseStatusesQueryVariables>(
    CloseStatusesDocument,
    options,
  );
}
export function useCloseStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CloseStatusesQuery,
    CloseStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CloseStatusesQuery, CloseStatusesQueryVariables>(
    CloseStatusesDocument,
    options,
  );
}
export function useCloseStatusesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CloseStatusesQuery,
        CloseStatusesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CloseStatusesQuery,
    CloseStatusesQueryVariables
  >(CloseStatusesDocument, options);
}
export type CloseStatusesQueryHookResult = ReturnType<
  typeof useCloseStatusesQuery
>;
export type CloseStatusesLazyQueryHookResult = ReturnType<
  typeof useCloseStatusesLazyQuery
>;
export type CloseStatusesSuspenseQueryHookResult = ReturnType<
  typeof useCloseStatusesSuspenseQuery
>;
export type CloseStatusesQueryResult = Apollo.QueryResult<
  CloseStatusesQuery,
  CloseStatusesQueryVariables
>;
export const StateApproveHistoriesDocument = gql`
  query StateApproveHistories(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: StateApproveHistoryQueryInput
    $order: [StateApproveHistoryOrderInput]
  ) {
    stateApproveHistories(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
    ) {
      edges {
        node {
          ...stateApproveHistoryItem
        }
      }
      total
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
  ${StateApproveHistoryItemFragmentDoc}
`;

/**
 * __useStateApproveHistoriesQuery__
 *
 * To run a query within a React component, call `useStateApproveHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateApproveHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStateApproveHistoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      query: // value for 'query'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStateApproveHistoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StateApproveHistoriesQuery,
    StateApproveHistoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StateApproveHistoriesQuery,
    StateApproveHistoriesQueryVariables
  >(StateApproveHistoriesDocument, options);
}
export function useStateApproveHistoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StateApproveHistoriesQuery,
    StateApproveHistoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StateApproveHistoriesQuery,
    StateApproveHistoriesQueryVariables
  >(StateApproveHistoriesDocument, options);
}
export function useStateApproveHistoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StateApproveHistoriesQuery,
        StateApproveHistoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StateApproveHistoriesQuery,
    StateApproveHistoriesQueryVariables
  >(StateApproveHistoriesDocument, options);
}
export type StateApproveHistoriesQueryHookResult = ReturnType<
  typeof useStateApproveHistoriesQuery
>;
export type StateApproveHistoriesLazyQueryHookResult = ReturnType<
  typeof useStateApproveHistoriesLazyQuery
>;
export type StateApproveHistoriesSuspenseQueryHookResult = ReturnType<
  typeof useStateApproveHistoriesSuspenseQuery
>;
export type StateApproveHistoriesQueryResult = Apollo.QueryResult<
  StateApproveHistoriesQuery,
  StateApproveHistoriesQueryVariables
>;
